/*
 * LoamLabs Spoke Color Studio (standalone module).
 * Plain JavaScript, no libraries, no build step. The only global is window.LoamStudio.
 * Pair with spoke-studio.css (every class there is prefixed lls-).
 *
 *   LoamStudio.open({ config, value, onChange(value, info), onClose(value, info) })
 *   LoamStudio.close()                  close programmatically (same as the X)
 *   LoamStudio.isOpen()
 *   LoamStudio.defaults(config)         the value a fresh Studio starts from
 *   LoamStudio.derive(value, config)    { counts, custom, customCount, fee, replaced, replacedDetail }
 *                                       (with a full config the value is checked against the palettes first, exactly as open() does;
 *                                        with just { fee } it only counts)
 *   LoamStudio.preview(el, { config, value, wheel, size, pov })   small non-interactive wheel -> { update(value), destroy(), replaced }
 *   LoamStudio.geometry(config)         computed lacing, for tests and the printed map
 *
 * Patterns: Solid / 2 x 2 (2 x 1 on 2:1 wheels) / Every 4th (Every 3rd on 2:1 wheels) / Clear replace both sides. All of them count around the whole wheel by rim
 * position, clockwise from the first rim hole clockwise of the valve stem (vrank 0). Every 4th paints vrank = r, r+4, r+8 ... (r = 0..3);
 * on a wheel whose two sides have different spoke counts the same button reads Every 3rd and paints r, r+3, r+6 ... (r = 0..2).
 * 2 x 2 paints a pair of neighbouring holes, skips a pair, and so on (painted when (vrank + 1 - r) mod 4 is 0 or 1; r = 0..3). On 2:1 wheels
 * the same button reads 2 x 1: a pair, then one skipped hole (painted when (vrank + 1 - r) mod 3 is 0 or 1; r = 0..2). At r = 0 the first pair
 * is the two spokes around the valve stem (vrank nh-1 and 0).
 * The small arrow on those tiles moves the pattern one hole clockwise per click. A button is outlined while the accent-colored spokes
 * equal its pattern at ANY rotation (read from the spokes, nothing is stored); Drive side / Rotor side are outlined when exactly that
 * side's spokes are accent. Drive side / Rotor side: clicking X steps X back if X is all accent; else paints X if the other side is one
 * solid non-base color; else (a lit pattern) resets the whole wheel and paints X; else just paints X.
 *
 * info (second argument of onChange / onClose and the result of derive):
 *   counts   { wheel: { colorName: n } }      custom  { wheel: bool }      customCount, fee
 *   replaced        how many saved colors were swapped on open because they are no longer in the palettes (0 = nothing changed)
 *   replacedDetail  { spokes, base, hub, accent }
 *
 * config = {
 *   // ---- palettes (data-driven; the module has no built-in colors) ----
 *   spokeColors: [{ name, hex }, ...],                       // REQUIRED. Dock, Base and Accent pickers, chips and the drawing use this.
 *   hubColors: { front: [{ name, hex }, ...], rear: [...] }, // The Hub picker offers only these (the colors that hub comes in).
 *                                                            // On the Both tab it offers the colors both hubs share.
 *   // A color with no (or an invalid) hex is drawn as a neutral gray swatch and keeps its name; it never throws.
 *   // 4 to 20 spoke colors lay out fine (the dock wraps and the wheel shrinks a little for a second row).
 *
 *   // Optional photo rim (per wheel: wheels.front.rimImage / wheels.rear.rimImage; config.rimImage is the default for every wheel). Without it the
 *   // rim is the CSS ring, exactly as before. With it the ring is drawn from a transparent photo of a rim (an alpha PNG / WebP, rim seen flat-on),
 *   // layered ABOVE the spokes (spoke ends tuck 1 to 2 px under the ring's inner edge), the valve stem on top of the ring. All numbers are pixels of
 *   // the image file (it is `size` x `size`); angles are degrees, an ellipse's rx axis points at `angle` measured from the image's +x axis towards +y
 *   // (clockwise on screen). Spokes end on the INNER ellipse: r(a) = rx*ry / sqrt((ry*cos(a - angle))^2 + (rx*sin(a - angle))^2), taken from the
 *   // inner ellipse's center. The image is scaled so the mean outer radius, (outerRx + outerRy) / 2, equals the Studio's outer rim radius, and placed
 *   // so the outer ellipse's center is the wheel center.
 *   //   rimImage: { src: 'https://.../scs-rim-wao.webp', size: 1024,
 *   //     outerRx, outerRy, outerCx, outerCy,                   // outer edge ellipse (outerCx / outerCy default size / 2)
 *   //     innerRx, innerRy, innerAngleDeg, innerCx, innerCy,    // inner edge ellipse (the spokes end on it)
 *   //     valveAngleDeg: 1.77,   // where the photo's own valve mark is, measured from straight down towards the viewer's RIGHT, in the photo as supplied
 *   //                            // (0 when the photo has none); the ring is turned clockwise by this so the mark sits under the Studio's valve stem
 *   //     rotationDeg: 0,        // extra clockwise turn (a photo without a valve mark: where its decals land); the photo is never mirrored, so
 *   //                            // decals read the right way round from both sides. Invalid or incomplete -> ignored (CSS ring).
 *   //     decalAngleDeg: 266.46 }  // optional, informational: angle of the small decal's center, clockwise from 12 o'clock, in the photo as supplied
 *   //                            // (the I9 photo: rotationDeg = 360 - decalAngleDeg puts that decal at 12 o'clock, opposite the valve stem)
 *   // LoamStudio.rimImage(vendor, { position }) returns the ring for a rim brand ("Industry Nine" -> the I9 ring, every other brand -> the We Are One
 *   // ring) with the numbers above filled in; the image files are found next to spoke-studio.js, or from LoamStudio.rimImageUrls / window.LoamRimImageUrls.
 *
 *   // Optional valve stem color (Presta look: a thin stem with a flat top on a small rectangular nut, one color). Default #2b2b2b. A light color
 *   // (silver, white, gold) gets a thin darker edge. Sizes are fractions of the wheel picture width S: stem 0.0068 S thick and 0.0483 S high from the
 *   // rim's inner edge, nut 0.0164 S wide and 0.0041 S high on the inner edge (LoamStudio.valve holds the numbers).
 *   //   valveColor: { front: '#c0392b', rear: '#2b2b2b' },   // per wheel, both optional; wheels.front.valveColor / wheels.rear.valveColor also work
 *   //                                                        // (a single '#rrggbb' string = both wheels). Hosts redraw by passing a new config (or
 *   //                                                        // I9System.setValveColor / StandardStudio.setValveColor, or the window event 'loam:valve-color').
 *
 *   title: 'I9 Solix \u00b7 front and rear wheels',           // optional
 *   fee: { amount: 25, currency: 'USD', locale: 'en-US' },   // optional, display only: the per-wheel custom-color fee (currency / locale optional)
 *   theme: 'dark' | 'light',                                 // optional first-visit theme
 *   startWheel: 'front' | 'rear' | 'both',                   // optional
 *   defaultBase: 'Black', defaultAccent: 'Orange',           // optional names from spokeColors (else first / second color)
 *   onFeedback: function (payload) {},                       // optional, mock only (no network here)
 *   feeFor: function (info) { return { amount: 25, label: 'Custom spoke colors' }; }, // optional. info = { wheel: 'front'|'rear',
 *                                                            //   counts: { '<color name>': spokes }, base: { drive, rotor } }. When present the
 *                                                            //   fee box shows a wheel only while amount > 0 (its own amount and label; the Both
 *                                                            //   tab shows one line per wheel) and config.fee is ignored. Re-run on every change,
 *                                                            //   undo and redo. Currency / locale: config.fee { currency, locale } (no amount needed).
 *                                                            //   Absent -> the fixed config.fee, shown muted / accent by "more than one color".
 *   feeInfo: { title: 'Custom spoke color fees',            // optional. When present, the fee box becomes a button (with a small "i") that opens a
 *             rows: [ { label: 'Two or more colors on a wheel', //   popup: the title, one line per row (label, amount formatted with the currency of
 *                       amount: 25,                              //   config.fee, the "when" text) and the note. All wording comes from the host; the
 *                       when: 'Black and silver, or any mix.' } ], //   Studio only adds the Close button. Absent -> the fee box is not clickable.
 *             note: 'The fee is per wheel.',                     //   (note is optional; a row's amount and when are optional too)
 *             idle: 'No color fee yet' },                        //   optional text: while NO fee applies the box is still shown, with this text and the
 *                                                                //   same "i" (one box, also on the Both tab). Absent / empty -> no box until a fee applies.
 *   onFeedbackRequest: function ({ value, info }) {},        // optional. When present, the "Send feedback or report a problem" link calls it
 *                                                            // instead of opening the built-in mock form. The host shows its own popup above
 *                                                            // the Studio; while focus is inside that popup the Studio ignores Esc / Tab, so
 *                                                            // Esc closes only the popup. Give focus back to the link when the popup closes.
 *   autoValvePhase: true,                                    // optional (default false). true: the valve stem sits between the two MOST PARALLEL
 *                                                            //   spokes. The Studio tries every whole-rim-hole rotation of the lacing and keeps the
 *                                                            //   one with the smallest angle between the spokes in the two rim holes beside the valve
 *                                                            //   (ties: nearest the default phase, then clockwise). Replaces the hand-calibrated phases
 *                                                            //   for this config. Absent / false: nothing changes.
 *   rimHolePhase: 1,                                         // optional, 1:1 hubs only (2:1 ignores it); can also be set per wheel.
 *                                                            // 1 (default): rotor side takes the odd-index rim holes, drive side the even ones. 0: swapped.
 *   wheels: {                                                // 'front' and/or 'rear'
 *     rear: {
 *       hubName: 'Solix', hubColor: 'Purple',                // hubColor = the color shown until the value says otherwise
 *       sideLabels: { drive: 'Drive side', rotor: 'Rotor side' }, // optional: the words used for the two sides on this wheel everywhere
 *                                                            // ("Left side" / "Right side" for a rim-brake front, say)
 *       erd: 568, rimHoles: 24,
 *       drive: { n: 16, pcd: 52, cross: 3.5 },               // spokes on the drive side, hub spoke-circle diameter, crossing (0 = radial)
 *       rotor: { n: 8,  pcd: 40, cross: 1.4 }
 *     }, front: { ... }
 *   }
 * }
 *
 * value = { v:1, hubColor:{front,rear}, base:{front:{drive,rotor},rear:{...}},
 *           spokes:{front:{drive:[names],rotor:[names]},rear:{...}}, accent }
 * Spoke index k is as drawn in the drive-side point of view. Pure data in, pure data out.
 * On open, any spoke or base color that is not in config.spokeColors is replaced by the (valid) base color, a base color by the default
 * base, a hub color that is not in that wheel's hubColors by the wheel's hubColor / first hub color, and a missing accent by the default accent.
 */
(function (global) {
  'use strict';

  /* ------------------------------------------------------------------ constants */
  var SIDES = ['drive', 'rotor'];
  var WHEEL_ORDER = ['front', 'rear'];
  var THEME_KEY = 'loamStudioTheme';
  var DOT = '\u00b7', TIMES = '\u00d7';
  var TOAST_MS = 1900;

  var S = null; // the one open session

  /* ------------------------------------------------------------------ small helpers */
  function esc(s) {
    return String(s).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;');
  }
  function cap(s) { return s.charAt(0).toUpperCase() + s.slice(1); }
  function filled(n, v) { var a = [], i; for (i = 0; i < n; i++) a.push(v); return a; }
  function num(v, d) { v = Number(v); return isFinite(v) && v > 0 ? v : d; }
  // Currency comes from config.fee { currency: 'USD', locale: 'en-US' } (both optional); plain "$25.00" if Intl is missing.
  function money(n, fee) {
    try {
      return new Intl.NumberFormat((fee && fee.locale) || undefined, { style: 'currency', currency: (fee && fee.currency) || 'USD' }).format(n);
    } catch (e) { return '$' + n.toFixed(2); }
  }
  function warn(msg) { if (global.console && global.console.warn) global.console.warn('[LoamStudio] ' + msg); }
  function safe(fn, a, b) { try { return fn(a, b); } catch (err) { if (global.console && global.console.error) global.console.error(err); } }
  function diff(a, b) { return Math.abs(((a - b + 540) % 360) - 180); }
  function dict() { return Object.create(null); }
  function has(o, k) { return o != null && Object.prototype.hasOwnProperty.call(o, k); }
  var NEUTRAL = '#8a9099';
  var HEX_RE = /^(#[0-9a-fA-F]{3,8}|(rgb|hsl)a?\([0-9\s.,%\/-]+\))$/;
  // A palette entry is { name, hex }. Bad hex (or none) -> neutral gray swatch, name kept. Duplicate names: first wins.
  function cleanList(list) {
    var out = [], seen = dict();
    (Array.isArray(list) ? list : []).forEach(function (c) {
      var name = typeof c === 'string' ? c : (c && c.name != null ? String(c.name) : '');
      if (!name || seen[name]) return;
      seen[name] = 1;
      var hex = c && typeof c.hex === 'string' ? c.hex.trim() : '';
      out.push({ name: name, hex: HEX_RE.test(hex) ? hex : NEUTRAL, missingHex: !HEX_RE.test(hex) });
    });
    return out;
  }
  function hexMap(list) { var m = dict(); list.forEach(function (p) { m[p.name] = p.hex; }); return m; }
  function lsGet(k) { try { return global.localStorage.getItem(k); } catch (e) { return null; } }
  function lsSet(k, v) { try { global.localStorage.setItem(k, v); } catch (e) { /* storage blocked: fine */ } }

  /* ------------------------------------------------------------------ config + geometry */
  // Crossing as given: a number from 0 (radial) up; a missing / invalid value keeps the old default of 3.
  function crossOf(v) { return (v === 0 || v === '0') ? 0 : num(v, 3); }
  function cleanLabel(v, d) { v = v == null ? '' : String(v).replace(/\s+/g, ' ').trim(); return v || d; }

  // Valve stem (see the header): sizes are fractions of the picture width S. edge: how much darker (x) and how thick (px) the outline of a light stem is.
  var VALVE = { thick: 0.0068, height: 0.0483, nutW: 0.0164, nutH: 0.0041, color: '#2b2b2b', lightAbove: 0.5, edgeShade: 0.55, edgePx: 0.6 };
  // '#rgb' / '#rrggbb' -> '#rrggbb' (lower case); anything else -> null (the default color is used)
  function cleanValveColor(v) {
    v = typeof v === 'string' ? v.trim().toLowerCase() : '';
    if (/^#[0-9a-f]{3}$/.test(v)) return '#' + v.charAt(1) + v.charAt(1) + v.charAt(2) + v.charAt(2) + v.charAt(3) + v.charAt(3);
    return /^#[0-9a-f]{6}$/.test(v) ? v : null;
  }

  // Valve stem colors of the store (the 30 color texts of the component:valvestem products, lower case) -> [hex, light]. Source: agent-prompts/valve-colors/valve_color_map.json
  // (tests/valve-color.test.js keeps the two in step). An unknown text draws the default dark stem and warns once, so a new color gets noticed.
  var VALVE_COLORS = {
    "black": ["#2b2b2b", 0],
    "blue": ["#1f5fa8", 0],
    "bourbon": ["#9a5b25", 0],
    "bronze": ["#a0703a", 0],
    "eggplant": ["#4b2a4f", 0],
    "emerald": ["#1b7f5c", 0],
    "gold": ["#c9a227", 0],
    "gray": ["#7c7f83", 0],
    "green": ["#2f8f3a", 0],
    "intergalactic": ["#4a3f9a", 0],
    "iridescent": ["#7f8fc0", 0],
    "matte mango": ["#e08a1e", 0],
    "naranja": ["#e2661c", 0],
    "navy": ["#1e2f5a", 0],
    "oil slick": ["#3f4a5e", 0],
    "orange": ["#e5701b", 0],
    "pewter": ["#6f757b", 0],
    "pink": ["#d9608f", 0],
    "pink punch": ["#e0457f", 0],
    "purple": ["#6b3fa0", 0],
    "rasta": ["#c8202f", 0],
    "red": ["#c8202f", 0],
    "sasquatch (yeti)": ["#14a6b0", 0],
    "silver": ["#b8bcc2", 1],
    "sky blue": ["#5fa8dc", 0],
    "slate": ["#5b6670", 0],
    "sterling silver": ["#c2c6cc", 1],
    "titanium": ["#8c8f93", 0],
    "turquoise": ["#14a6b0", 0],
    "violet": ["#7c3fb3", 0]
  };
  var valveWarned = {};
  function valveColorHex(text) {
    var k = text == null ? '' : String(text).toLowerCase().replace(/\s+/g, ' ').trim();
    if (!k) return VALVE.color;
    var e = Object.prototype.hasOwnProperty.call(VALVE_COLORS, k) ? VALVE_COLORS[k] : null;
    if (e) return e[0];
    if (!valveWarned[k]) { valveWarned[k] = 1; if (global.console && console.warn) console.warn('unknown valve color: ' + k); }
    return VALVE.color;
  }
  // The valve color text of a stored valve stem component (its option named exactly 'Color'), or '' when it has none.
  function valveColorText(comp) {
    var o = comp && comp.selectedOptions; if (!Array.isArray(o)) return '';
    for (var i = 0; i < o.length; i++) if (o[i] && o[i].name === 'Color') return String(o[i].value == null ? '' : o[i].value);
    return '';
  }
  // { front, rear } as '#rrggbb' from buildState.components (or a saved build's components); a wheel with no valve stem = the default dark stem.
  function valveColorsOf(components) {
    var c = components || {};
    return { front: valveColorHex(valveColorText(c.frontValveStem)), rear: valveColorHex(valveColorText(c.rearValveStem)) };
  }

  // config.rimImage / wheels[pos].rimImage: a complete, finite description or nothing (then the CSS ring is drawn).
  function cleanRimImage(v) {
    if (!v || typeof v !== 'object' || typeof v.src !== 'string' || !v.src) return null;
    var n = function (x, d) { return x == null || x === '' ? d : Number(x); }, size = n(v.size, NaN);
    var o = { src: v.src, size: size, outerRx: n(v.outerRx, NaN), outerRy: n(v.outerRy, NaN), innerRx: n(v.innerRx, NaN), innerRy: n(v.innerRy, NaN),
      outerCx: n(v.outerCx, size / 2), outerCy: n(v.outerCy, size / 2), innerCx: n(v.innerCx, size / 2), innerCy: n(v.innerCy, size / 2),
      innerAngleDeg: n(v.innerAngleDeg, 0), valveAngleDeg: n(v.valveAngleDeg, 0), rotationDeg: n(v.rotationDeg, 0) };
    if (v.decalAngleDeg != null && v.decalAngleDeg !== '' && isFinite(Number(v.decalAngleDeg))) o.decalAngleDeg = Number(v.decalAngleDeg);
    var pos = ['size', 'outerRx', 'outerRy', 'innerRx', 'innerRy'], fin = ['outerCx', 'outerCy', 'innerCx', 'innerCy', 'innerAngleDeg', 'valveAngleDeg', 'rotationDeg'];
    if (!pos.every(function (k) { return isFinite(o[k]) && o[k] > 0; }) || !fin.every(function (k) { return isFinite(o[k]); }) || o.innerRx >= o.outerRx * 1.2 || o.innerRy >= o.outerRy * 1.2) { warn('rimImage ignored: incomplete or inconsistent numbers'); return null; }
    return o;
  }

  // config.feeInfo: only texts and numbers are kept; nothing usable (no title, rows or note) = no popup.
  function cleanFeeInfo(v) {
    if (!v || typeof v !== 'object') return null;
    var rows = (Array.isArray(v.rows) ? v.rows : []).filter(function (r) { return r && typeof r === 'object'; }).map(function (r) {
      var a = r.amount == null || r.amount === '' ? NaN : Number(r.amount);
      return { label: cleanLabel(r.label, ''), amount: isFinite(a) ? a : null, when: cleanLabel(r.when, '') };
    }).filter(function (r) { return r.label || r.amount != null || r.when; });
    var out = { title: cleanLabel(v.title, ''), rows: rows, note: cleanLabel(v.note, ''), idle: typeof v.idle === 'string' ? cleanLabel(v.idle, '') : '' };
    return out.title || out.rows.length || out.note ? out : null;
  }

  function normalizeConfig(cfg, needColors) {
    cfg = cfg || {};
    var palette = cleanList(cfg.spokeColors);
    if (!palette.length && needColors) throw new Error('LoamStudio: config.spokeColors must be a non-empty list of { name, hex }');
    var HEX = hexMap(palette);

    var W = {}, keys = [];
    WHEEL_ORDER.forEach(function (key) {
      var w = cfg.wheels && cfg.wheels[key];
      if (!w || !w.drive || !w.rotor) return;
      var nd = Math.round(num(w.drive.n, 0)), nr = Math.round(num(w.rotor.n, 0));
      if (!nd || !nr) { warn('wheel "' + key + '" needs drive.n and rotor.n'); return; }
      var total = nd + nr;
      if (w.rimHoles && Number(w.rimHoles) !== total) warn('wheel "' + key + '": rimHoles (' + w.rimHoles + ') does not match drive.n + rotor.n (' + total + '); using ' + total);
      // Hub colors: only the colors this hub comes in. With no list, fall back to the single configured hubColor.
      var hubList = cleanList(cfg.hubColors && cfg.hubColors[key]);
      if (!hubList.length) {
        if (needColors) warn('config.hubColors.' + key + ' is missing; the Hub picker will offer only "' + (w.hubColor || 'Standard') + '"');
        hubList = cleanList([{ name: w.hubColor || 'Standard', hex: HEX[w.hubColor] }]);
      }
      var hubHex = hexMap(hubList);
      W[key] = {
        key: key, label: cap(key) + ' wheel', hubName: w.hubName || '',
        hubColors: hubList, hubHex: hubHex, hubColor: has(hubHex, w.hubColor) ? w.hubColor : hubList[0].name,
        erd: num(w.erd, 568), rimHoles: total, ratio: nd === nr ? '1:1' : '2:1', autoValve: cfg.autoValvePhase === true,
        rimHolePhase: Number(w.rimHolePhase != null ? w.rimHolePhase : (cfg.rimHolePhase != null ? cfg.rimHolePhase : 1)) === 0 ? 0 : 1,
        drive: { n: nd, pcd: num(w.drive.pcd, 50), cross: crossOf(w.drive.cross) },
        rotor: { n: nr, pcd: num(w.rotor.pcd, 50), cross: crossOf(w.rotor.cross) },
        rimImage: cleanRimImage(w.rimImage != null ? w.rimImage : cfg.rimImage),
        valveColor: cleanValveColor(w.valveColor != null ? w.valveColor : (cfg.valveColor && typeof cfg.valveColor === 'object' ? cfg.valveColor[key] : cfg.valveColor)) || VALVE.color,
        sideLabels: { drive: cleanLabel(w.sideLabels && w.sideLabels.drive, 'Drive side'), rotor: cleanLabel(w.sideLabels && w.sideLabels.rotor, 'Rotor side') },
        sideLabelsGiven: { drive: !!cleanLabel(w.sideLabels && w.sideLabels.drive, ''), rotor: !!cleanLabel(w.sideLabels && w.sideLabels.rotor, '') }
      };
      keys.push(key);
    });
    if (!keys.length) throw new Error('LoamStudio: config.wheels needs at least one of front / rear');

    var fee = null;
    if (cfg.fee && num(cfg.fee.amount, 0)) fee = { amount: Number(cfg.fee.amount), currency: cfg.fee.currency, locale: cfg.fee.locale };
    var feeFmt = cfg.fee ? { currency: cfg.fee.currency, locale: cfg.fee.locale } : {};

    var title = cfg.title;
    if (!title) {
      var hn = W[keys[0]].hubName;
      title = (hn ? hn + ' ' + DOT + ' ' : '') + (keys.length === 2 ? 'front and rear wheels' : keys[0] + ' wheel');
    }
    var base = has(HEX, cfg.defaultBase) ? cfg.defaultBase : (palette.length ? palette[0].name : '');
    var accent = has(HEX, cfg.defaultAccent) ? cfg.defaultAccent : (palette.length ? (palette[1] || palette[0]).name : '');
    return { raw: cfg, W: W, keys: keys, palette: palette, HEX: HEX, fee: fee, feeFmt: feeFmt, feeInfo: cleanFeeInfo(cfg.feeInfo), title: title, defaultBase: base, defaultAccent: accent };
  }

  // Rim holes sit at half-steps so the valve (6 o'clock) lands between two holes. They alternate
  // drive / rotor: 1:1 alternates; for 2:1 the minority side gets every third hole (spread evenly for other ratios).
  function rimHoles(w) {
    var nh = w.rimHoles, nd = w.drive.n, nr = w.rotor.n, d = [], r = [], j;
    var minority = Math.min(nd, nr);
    for (j = 0; j < nh; j++) {
      var a = (j + 0.5) * 360 / nh, toRotor;
      if (nd === nr) toRotor = (j % 2) === (w.rimHolePhase === 0 ? 0 : 1); // 1:1 only; 2:1 layouts ignore the phase
      else {
        var isMin = Math.floor(j * minority / nh) !== Math.floor((j - 1) * minority / nh);
        toRotor = (nr < nd) ? isMin : !isMin;
      }
      (toRotor ? r : d).push(a);
    }
    return { drive: d, rotor: r };
  }

  // Each hub hole goes to the rim hole nearest its laced target (crossing sets the sweep angle).
  // phase = angular offset of the hub holes (illustrative, not engineering-accurate).
  function assign(n, cross, holes, phase) {
    if (cross === 0) { // radial: every spoke runs straight out, so each hub hole sits at the angle of its own rim hole
      var rad = holes.slice().sort(function (a, b) { return a - b; });
      return rad.map(function (a, i) { return { hub: a, rim: a, s: i % 2 === 0 ? 1 : -1 }; });
    }
    var delta = 360 * cross / n, tg = [], k, i, r;
    for (k = 0; k < n; k++) {
      var h = k * 360 / n + phase, s = k % 2 === 0 ? 1 : -1;
      tg.push({ k: k, h: h % 360, t: (((h + s * delta) % 360) + 360) % 360 });
    }
    tg.sort(function (a, b) { return a.t - b.t || a.k - b.k; });
    var hs = holes.slice().sort(function (a, b) { return a - b; }), best = 1e9, bs = 0;
    for (r = 0; r < n; r++) {
      var c = 0;
      for (i = 0; i < n; i++) c += diff(tg[i].t, hs[(i + r) % n]);
      if (c < best) { best = c; bs = r; }
    }
    var out = new Array(n);
    for (i = 0; i < n; i++) out[tg[i].k] = { hub: tg[i].h, rim: hs[(i + bs) % n], s: tg[i].k % 2 === 0 ? 1 : -1 };
    return out;
  }

  // 2:1 wheels, MAJORITY side (rear drive side, front rotor side). Leading and trailing spokes alternate (k even / k odd), so a correct lacing has
  // 8-fold (n/2-fold) symmetry: every even spoke sits the same distance from its laced target, and every odd spoke too. The rim holes of this
  // side come in pairs (the minority side takes every third hole), and the two spoke parities each take ONE hole of every pair:
  //   MAJORITY_ODD_TAKES_LOWER = true  -> odd spokes take the lower-angle hole of each pair, even spokes the upper one
  //                                       (24h 2:1 rear: evens k0,k2.. -> 82.5,127.5,... deviation -11.25; odds k1,k3.. -> 337.5,22.5,... +18.75).
  // Flip this one constant if the real lacing turns out to be the other way round.
  var MAJORITY_ODD_TAKES_LOWER = true;
  function assignMajority(n, cross, holes, phase) {
    var delta = 360 * cross / n, hs = holes.slice().sort(function (a, b) { return a - b; }), m = n / 2, k, i, r, j;
    // find the pairs: small gap = the two holes of one pair
    var mean = 360 / n, start = -1;
    for (i = 0; i < n; i++) { if (((hs[(i + 1) % n] - hs[i] + 360) % 360) < mean) { start = i; break; } }
    if (start < 0) return null;
    var lower = [], upper = [];
    for (j = 0; j < m; j++) {
      var a = hs[(start + 2 * j) % n], b = hs[(start + 2 * j + 1) % n];
      if (((b - a + 360) % 360) >= mean) return null; // not a clean pair structure
      lower.push(a); upper.push(b);
    }
    var out = new Array(n);
    [0, 1].forEach(function (parity) {
      var useLower = parity === 1 ? MAJORITY_ODD_TAKES_LOWER : !MAJORITY_ODD_TAKES_LOWER;
      var set = (useLower ? lower : upper).slice().sort(function (x, y) { return x - y; }), tg = [];
      for (k = parity; k < n; k += 2) {
        var h = k * 360 / n + phase, sgn = k % 2 === 0 ? 1 : -1;
        tg.push({ k: k, h: h % 360, t: (((h + sgn * delta) % 360) + 360) % 360 });
      }
      tg.sort(function (x, y) { return x.t - y.t || x.k - y.k; });
      var best = 1e9, bs = 0;
      for (r = 0; r < m; r++) {
        var c = 0;
        for (i = 0; i < m; i++) c += diff(tg[i].t, set[(i + r) % m]);
        if (c < best - 1e-9) { best = c; bs = r; }
      }
      for (i = 0; i < m; i++) out[tg[i].k] = { hub: tg[i].h, rim: set[(i + bs) % m], s: tg[i].k % 2 === 0 ? 1 : -1 };
    });
    return out;
  }

  // ONE place for the lacing phase of each wheel: rotates the WHOLE lacing (hub holes, spoke-to-rim-hole assignment and which rim holes belong to
  // which side) rigidly relative to the rim and the valve. Every spoke keeps its sweep and deviation; the set of rim hole angles and the valve do
  // not move, so vrank and the patterns stay put (only which side owns which rim hole can shift on a 2:1 wheel).
  //   Key   = '<position>:<hub count>'   (hub count = total spokes = rim holes)
  //   Value = rotation in RIM HOLES (one hole = 360 / hub count degrees).
  //   SIGN  = angles in this file are the drive-side view, measured clockwise from 12 o'clock:
  //           positive = clockwise seen from the DRIVE side, negative = counter-clockwise seen from the drive side
  //           (= clockwise seen from the ROTOR side, because the rotor view is the mirror image).
  //   Hydra2 front 32h : -2  the valve stem sits between parallel spokes (2 holes counter-clockwise, drive-side view)
  //   (Solix 24h 2:1 front and rear are NOT here any more: their lacing is the explicit LACING_2TO1_24H table below.)
  //   Hydra2 rear 28h  : +2  (not sold today) 2 holes clockwise seen from the DRIVE side, chosen by Jerry from a sample image. On a 28h hub
  //                      +2 and -2 draw the same wheel (14 spokes per side = 7-fold lacing symmetry); only spoke numbering k differs. The
  //                      PCD and crossing used for it are SAMPLE numbers: recheck if I9 releases a real 28h rear with different ones.
  // When the step is a whole number of hub holes the spokes are re-counted from the hub holes (k = 0 is the hub hole at the usual start angle);
  // otherwise the hub holes turn with the lacing and spoke index k is kept.
  var LACING_PHASE_HOLES = { 'front:32': -2, 'rear:28': 2 };
  function rotateLacing(list, stepDeg) {
    var n = list.length, pitch = 360 / n, q = Math.round(stepDeg / pitch), whole = Math.abs(stepDeg - q * pitch) < 1e-6;
    return list.map(function (_, k) {
      var o = list[whole ? (((k - q) % n) + n) % n : k];
      return { hub: (((o.hub + stepDeg) % 360) + 360) % 360, rim: (((o.rim + stepDeg) % 360) + 360) % 360, s: o.s };
    });
  }

  // Solix 24h 2:1 lacing as measured on real I9 System wheels (Jerry, approved from a render). Angles are drive-view degrees, clockwise from 12 o'clock;
  // rim holes sit at 7.5, 22.5 ... 352.5 and the valve at 180 (between holes 172.5 and 187.5). Spoke k of a side has its hub hole at
  // hub0 + k * (360 / spokes on that side); an EVEN k leans one way (s = +1, rim = hub + pos) and an ODD k the other way (s = -1, rim = hub + neg).
  // Which rim holes belong to which side simply follows from rim = hub + sweep. Keyed by the position, the side that carries the 16 spokes is
  // 'major' (high tension: front = rotor side, rear = drive side) and the 8-spoke side 'minor' (low tension).
  //   front: the 8 low-tension (drive) rim holes are 22.5, 67.5, ... 337.5 (every 45); the valve sits between two HIGH-tension holes (172.5, 187.5).
  //   rear : the exact mirror image, left to right (every rim angle a -> 360 - a, every sweep changes sign, high tension = drive side).
  // Only used for an exact 24h 2:1 wheel (16 + 8 spokes); every other wheel keeps the generic lacing above.
  var LACING_2TO1_24H = {
    front: { major: { hub0: 315, pos: 82.5, neg: -60 }, minor: { hub0: 315, pos: 22.5, neg: -67.5 } },
    rear: { major: { hub0: 22.5, pos: 60, neg: -82.5 }, minor: { hub0: 0, pos: 67.5, neg: -22.5 } }
  };
  function lacingFromTable(spec, n) {
    var out = [], k, pitch = 360 / n;
    for (k = 0; k < n; k++) {
      var s = k % 2 === 0 ? 1 : -1, hub = (((spec.hub0 + k * pitch) % 360) + 360) % 360;
      out.push({ hub: hub, rim: (((hub + (s > 0 ? spec.pos : spec.neg)) % 360) + 360) % 360, s: s });
    }
    return out;
  }

  // autoValvePhase: angle (degrees) between the two spokes in the rim holes either side of the valve, as drawn (hub hole point to rim hole point;
  // hub radius = pcd / 2, rim radius = erd / 2, the same ratio the wheel is drawn with). 0 = parallel. Radial spokes: always 360 / holes.
  function valveAngle(w, lacing) {
    var step = 180 / w.rimHoles, want = [180 - step, 180 + step], best = [null, null];
    SIDES.forEach(function (side) {
      lacing[side].forEach(function (p) {
        want.forEach(function (a, i) {
          var d = diff(p.rim, a);
          if (!best[i] || d < best[i].d) best[i] = { d: d, p: p, side: side };
        });
      });
    });
    var v = best.map(function (b) {
      var rh = w[b.side].pcd / 2, rr = w.erd / 2, a1 = b.p.hub * Math.PI / 180, a2 = b.p.rim * Math.PI / 180;
      return [rr * Math.sin(a2) - rh * Math.sin(a1), rr * Math.cos(a2) - rh * Math.cos(a1)];
    });
    return Math.atan2(Math.abs(v[0][0] * v[1][1] - v[0][1] * v[1][0]), v[0][0] * v[1][0] + v[0][1] * v[1][1]) * 180 / Math.PI;
  }
  // The whole-hole rotation (positive = clockwise, drive-side view) with the smallest valve angle. Equal angles (the pattern repeats, radial) go to the
  // rotation nearest 0 (the default phase), then to the clockwise one, so the answer is deterministic.
  function autoValveHoles(w, lacing) {
    var N = w.rimHoles, tries = [], q, lo = -Math.floor((N - 1) / 2), hi = Math.floor(N / 2);
    for (q = lo; q <= hi; q++) {
      var t = {};
      SIDES.forEach(function (side) { t[side] = rotateLacing(lacing[side], q * 360 / N); });
      tries.push({ q: q, a: valveAngle(w, t) });
    }
    var min = Math.min.apply(null, tries.map(function (x) { return x.a; })), pick = null;
    tries.forEach(function (x) {
      if (x.a > min + 1e-7) return;
      if (!pick || Math.abs(x.q) < Math.abs(pick.q) || (Math.abs(x.q) === Math.abs(pick.q) && x.q > pick.q)) pick = x;
    });
    return pick.q;
  }

  function buildGeom(W) {
    var G = {};
    Object.keys(W).forEach(function (key) {
      var w = W[key], h = rimHoles(w);
      // 1:1 hubs: stagger the two flanges by half a hole pitch so the two sides do not draw on top of each other.
      var rotorPhase = w.ratio === '1:1' ? 15 + 180 / w.rotor.n : 15;
      G[key] = {
        drive: assign(w.drive.n, w.drive.cross, h.drive, 15),
        rotor: assign(w.rotor.n, w.rotor.cross, h.rotor, rotorPhase)
      };
      // exact 2:1: the majority side uses the symmetry-aware assignment (the minority side and 1:1 wheels keep the plain one)
      var big = w.drive.n > w.rotor.n ? 'drive' : 'rotor', small = big === 'drive' ? 'rotor' : 'drive';
      if (w.drive.n !== w.rotor.n && w[big].n === 2 * w[small].n) {
        var sym = assignMajority(w[big].n, w[big].cross, h[big], big === 'drive' ? 15 : rotorPhase);
        if (sym) G[key][big] = sym;
      }
      var table = LACING_2TO1_24H[key], phaseHoles = LACING_PHASE_HOLES[key + ':' + w.rimHoles];
      if (w.autoValve) {
        var autoQ = autoValveHoles(w, G[key]);
        if (autoQ) SIDES.forEach(function (side) { G[key][side] = rotateLacing(G[key][side], autoQ * 360 / w.rimHoles); });
      } else if (table && w.rimHoles === 24 && w[big].n === 16 && w[small].n === 8) {
        G[key][big] = lacingFromTable(table.major, 16);
        G[key][small] = lacingFromTable(table.minor, 8);
      } else if (phaseHoles) SIDES.forEach(function (side) { G[key][side] = rotateLacing(G[key][side], phaseHoles * 360 / w.rimHoles); });
      // rank = this spoke's position (0..N-1) among ALL spokes of the wheel (both sides together), counting clockwise around the
      // rim from 12 o'clock, drive-side point of view. rimIndex = hole number on the whole rim.
      var all = [];
      SIDES.forEach(function (side) { G[key][side].forEach(function (p) { all.push(p); }); });
      all.sort(function (a, b) { return a.rim - b.rim; });
      all.forEach(function (p, r) { p.rank = r; p.rimIndex = Math.round(p.rim * w.rimHoles / 360 - 0.5); });
      // vrank = the same spokes counted clockwise (as seen from the drive side) starting at the valve stem, which the Studio draws at
      // 6 o'clock (180 degrees): vrank 0 is the first spoke clockwise of the stem (the nearest one to the left of it in the default
      // drive view). Every pattern counts by it, so the first painted spoke is the same place on every wheel.
      var byValve = all.slice().sort(function (a, b) { return ((a.rim - 180 + 360) % 360) - ((b.rim - 180 + 360) % 360); });
      byValve.forEach(function (p, r) { p.vrank = r; });
    });
    return G;
  }

  /* ------------------------------------------------------------------ value <-> snapshots */
  function nullsFor(spokes) {
    var o = {};
    Object.keys(spokes).forEach(function (w) { o[w] = { drive: filled(spokes[w].drive.length, null), rotor: filled(spokes[w].rotor.length, null) }; });
    return o;
  }
  function cloneSnap(s) {
    var o = { spokes: {}, prev: {}, hub: {}, base: {} };
    Object.keys(s.spokes).forEach(function (w) {
      o.spokes[w] = { drive: s.spokes[w].drive.slice(), rotor: s.spokes[w].rotor.slice() };
      o.prev[w] = { drive: s.prev[w].drive.slice(), rotor: s.prev[w].rotor.slice() };
      o.hub[w] = s.hub[w];
      o.base[w] = { drive: s.base[w].drive, rotor: s.base[w].rotor };
    });
    return o;
  }
  // Builds a clean snapshot from a saved value. Colors that are no longer in the palettes are replaced and counted in snap.replaced.
  function snapFromValue(C, value, only) {
    var snap = { spokes: {}, prev: {}, hub: {}, base: {}, replaced: { spokes: 0, base: 0, hub: 0, accent: 0 } };
    var ok = value && typeof value === 'object';
    (only || C.keys).forEach(function (key) {
      var w = C.W[key];
      var hc = ok && value.hubColor ? value.hubColor[key] : null;
      if (hc != null && !has(w.hubHex, hc)) snap.replaced.hub++;
      snap.hub[key] = (hc != null && has(w.hubHex, hc)) ? hc : w.hubColor;
      snap.base[key] = {}; snap.spokes[key] = {}; snap.prev[key] = {};
      SIDES.forEach(function (side) {
        var b = ok && value.base && value.base[key] ? value.base[key][side] : null;
        if (b != null && !has(C.HEX, b)) snap.replaced.base++;
        b = (b != null && has(C.HEX, b)) ? b : C.defaultBase;
        var arr = ok && value.spokes && value.spokes[key] ? value.spokes[key][side] : null;
        var n = w[side].n;
        snap.base[key][side] = b;
        snap.spokes[key][side] = (Array.isArray(arr) && arr.length === n)
          ? arr.map(function (c) { if (has(C.HEX, c)) return c; snap.replaced.spokes++; return b; })
          : filled(n, b);
        snap.prev[key][side] = filled(n, null);
      });
    });
    return snap;
  }
  function replacedInfo(snap, accentReplaced) {
    var r = snap.replaced, d = { spokes: r.spokes, base: r.base, hub: r.hub, accent: accentReplaced ? 1 : 0 };
    return { replaced: d.spokes + d.base + d.hub + d.accent, replacedDetail: d };
  }
  function valueFromSnap(snap, accent) {
    var v = { v: 1, hubColor: {}, base: {}, spokes: {}, accent: accent };
    Object.keys(snap.spokes).forEach(function (w) {
      v.hubColor[w] = snap.hub[w];
      v.base[w] = { drive: snap.base[w].drive, rotor: snap.base[w].rotor };
      v.spokes[w] = { drive: snap.spokes[w].drive.slice(), rotor: snap.spokes[w].rotor.slice() };
    });
    return v;
  }
  // Counts per color per wheel + which wheels are custom. The value is expected to be clean already.
  function countValue(value, feeCfg) {
    var out = { counts: {}, custom: {}, customCount: 0, fee: 0 };
    if (!value || !value.spokes) return out;
    Object.keys(value.spokes).forEach(function (w) {
      var counts = {}, distinct = 0;
      SIDES.forEach(function (side) {
        (value.spokes[w][side] || []).forEach(function (c) {
          if (!has(counts, c)) { counts[c] = 0; distinct++; }
          counts[c]++;
        });
      });
      out.counts[w] = counts;
      out.custom[w] = distinct > 1;
      if (distinct > 1) out.customCount++;
    });
    var fee = feeCfg && feeCfg.fee && Number(feeCfg.fee.amount);
    if (fee) out.fee = fee * out.customCount;
    return out;
  }
  // derive(value, { fee }) only counts. derive(value, fullConfig) first applies the palettes (same replacement as open()).
  function derive(value, config) {
    if (config && config.wheels && config.spokeColors) {
      var C = normalizeConfig(config, false), sn = snapFromValue(C, value);
      var out = countValue(valueFromSnap(sn, null), config), r = replacedInfo(sn, false);
      out.replaced = r.replaced; out.replacedDetail = r.replacedDetail;
      return out;
    }
    var o = countValue(value, config);
    o.replaced = 0; o.replacedDetail = { spokes: 0, base: 0, hub: 0, accent: 0 };
    return o;
  }

  /* ------------------------------------------------------------------ drawing: kept apart so real photos can replace it later */
  function isVeryDark(hex) {
    var m = /^#([0-9a-f]{3}|[0-9a-f]{6})$/i.exec(String(hex).trim());
    if (!m) return false;
    var h = m[1].length === 3 ? m[1].replace(/./g, function (c) { return c + c; }) : m[1];
    return [0, 2, 4].every(function (i) { return parseInt(h.substr(i, 2), 16) <= 48; });
  }
  var arrowSeq = 0;

  /* ---------------------------------------------------------------- photo rims (config.rimImage, see the contract at the top) */
  var SCRIPT_SRC = (function () { try { return (global.document && global.document.currentScript && global.document.currentScript.src) || ''; } catch (e) { return ''; } })();
  // Measured from the 1024 px alpha images in agent-prompts/scs-rim-images (alpha > 50% edge, least-squares ellipse fit, residual <= 2.4 px).
  // WAO valve: Jerry marked it in the 620 px source: stem 1.77 deg RIGHT of straight down; the decal spans 1.96 deg left to 5.92 deg right of straight down.
  var RIM_PHOTOS = {
    wao: { file: 'scs-rim-wao.webp', size: 1024, outerRx: 510.23, outerRy: 510.62, outerAngleDeg: 14.16, outerCx: 513.07, outerCy: 512.66,
      innerRx: 475.4, innerRy: 475.86, innerAngleDeg: 7.43, innerCx: 513.28, innerCy: 512.08, valveAngleDeg: 1.77, rotation: { front: 0, rear: 0, other: 0 } },
    i9: { file: 'scs-rim-i9.webp', size: 1024, outerRx: 501.01, outerRy: 510.61, outerAngleDeg: 36.1, outerCx: 512.37, outerCy: 511.98,
      innerRx: 442.54, innerRy: 450.86, innerAngleDeg: 38.16, innerCx: 515.18, innerCy: 514, valveAngleDeg: 0, decalAngleDeg: 266.46,
      rotation: { front: 93.54, rear: 93.54, other: 93.54 } } // the I9 photo has no valve mark; Jerry marked its small dark decal at 266.46 deg (clockwise from 12 o'clock, 512,512 and the fitted center agree to 0.001 deg), real rims have it at 12 o'clock opposite the stem: turn the ring 360 - 266.46 = 93.54 deg clockwise, front and rear
  };
  var RIM_KEEP = {}; // src -> Image object, so the browser keeps the decoded photo
  var RIM_URLS = null; // set by LoamStudio.rimImageUrls({ wao, i9 })
  function rimUrl(key) {
    var u = RIM_URLS || (global.LoamRimImageUrls && typeof global.LoamRimImageUrls === 'object' ? global.LoamRimImageUrls : null);
    if (u && typeof u[key] === 'string' && u[key]) return u[key];
    if (SCRIPT_SRC && /spoke-studio\.js(\?.*)?$/.test(SCRIPT_SRC)) return SCRIPT_SRC.replace(/spoke-studio\.js(\?.*)?$/, RIM_PHOTOS[key].file + '$1');
    return '';
  }
  function rimImageFor(vendor, opts) {
    var key = /^\s*industry\s*nine\s*$/i.test(String(vendor == null ? '' : vendor)) ? 'i9' : 'wao', p = RIM_PHOTOS[key], src = rimUrl(key), pos = opts && opts.position;
    if (!src) return null;
    var rot = opts && isFinite(Number(opts.rotationDeg)) && opts.rotationDeg != null ? Number(opts.rotationDeg) : (p.rotation[pos] != null ? p.rotation[pos] : p.rotation.other);
    var out = {
      src: src, size: p.size, outerRx: p.outerRx, outerRy: p.outerRy, outerAngleDeg: p.outerAngleDeg, outerCx: p.outerCx, outerCy: p.outerCy,
      innerRx: p.innerRx, innerRy: p.innerRy, innerAngleDeg: p.innerAngleDeg, innerCx: p.innerCx, innerCy: p.innerCy, valveAngleDeg: p.valveAngleDeg, rotationDeg: rot
    };
    if (p.decalAngleDeg != null) out.decalAngleDeg = p.decalAngleDeg;
    return out;
  }
  // The ring's geometry in a wheel box of `box` px whose outer rim radius is ro: image placement, rotation, and the inner ellipse in box coordinates.
  function rimShape(ri, box, ro) {
    var s = ro / ((ri.outerRx + ri.outerRy) / 2), c = box / 2, rot = (ri.valveAngleDeg + ri.rotationDeg) * Math.PI / 180;
    var dx = (ri.innerCx - ri.outerCx) * s, dy = (ri.innerCy - ri.outerCy) * s, cs = Math.cos(rot), sn = Math.sin(rot);
    var sh = {
      s: s, rotDeg: ri.valveAngleDeg + ri.rotationDeg, left: c - ri.outerCx * s, top: c - ri.outerCy * s, px: ri.size * s, ox: ri.outerCx * s, oy: ri.outerCy * s,
      cx: c + dx * cs - dy * sn, cy: c + dx * sn + dy * cs, rx: ri.innerRx * s, ry: ri.innerRy * s, ang: ri.innerAngleDeg * Math.PI / 180 + rot
    };
    sh.meanR = (sh.rx + sh.ry) / 2;
    // point on the inner edge (plus `extra` px outwards) at drawn angle aDeg: clockwise from 12 o'clock, around the inner ellipse's center
    sh.end = function (aDeg, extra) {
      var a = aDeg * Math.PI / 180, ux = Math.sin(a), uy = -Math.cos(a), u = Math.atan2(uy, ux) - sh.ang;
      var r = sh.rx * sh.ry / Math.sqrt(Math.pow(sh.ry * Math.cos(u), 2) + Math.pow(sh.rx * Math.sin(u), 2)) + (extra || 0);
      return [sh.cx + r * ux, sh.cy + r * uy];
    };
    return sh;
  }
  // Spoke paint order inside ONE side: the spokes of one group (leading = the rim hole is clockwise of the hub hole in the drive-side view, i.e. ahead
  // of the hub in the rolling direction; trailing = counter-clockwise) are drawn first, the other group on top. FINAL_CROSS_TOP names the group
  // that is on top, so at the outermost crossing of a side every spoke of that group crosses over every spoke of the other group, whatever the colors.
  // Known simplification: a straight line is above or below another one, so the earlier crossings (which alternate on a real wheel) are not drawn as a weave.
  // Change the constant to 'leading' if the real wheel has it the other way round (LoamStudio.finalCrossTop() is the sandbox / test switch).
  var FINAL_CROSS_TOP = 'trailing';
  var ART = {
    // A spoke is a rotated line from a hub hole to a rim hole. Replace with a spoke photo here.
    // Visual spokes: crisp SVG lines (anti-aliased), a faint halo line under each core line. list = [{ x1, y1, x2, y2, hex }].
    //   dark theme: core 2.5 px on both sides at full opacity, white halo at 22% opacity 1.5 px wider; very dark spokes
    //   use core #0b0c0e. Light theme (and a light preview): core th with a dark edge 1px (0.5px when thin) each side, as before.
    spokeLayer: function (list, st) {
      var topS = FINAL_CROSS_TOP === 'leading' ? 1 : -1; // list[].s: +1 leading, -1 trailing
      var ordered = list.filter(function (q) { return q.s !== topS; }).concat(list.filter(function (q) { return q.s === topS; })); // stable: same order inside a group
      return '<g class="lls-sideg" data-side="' + st.side + '">' + ordered.map(function (q) {
        var core = st.dark && isVeryDark(q.hex) ? '#0b0c0e' : q.hex;
        var pos = ' x1="' + q.x1.toFixed(2) + '" y1="' + q.y1.toFixed(2) + '" x2="' + q.x2.toFixed(2) + '" y2="' + q.y2.toFixed(2) + '"';
        return '<line' + pos + ' stroke="' + st.haloCol + '" stroke-width="' + st.halo.toFixed(2) + '" stroke-opacity="' + st.haloOp + '"/>' +
          '<line' + pos + ' data-g="' + (q.s > 0 ? 'leading' : 'trailing') + '" stroke="' + esc(core) + '" stroke-width="' + st.th.toFixed(2) + '" stroke-opacity="' + st.op + '"/>';
      }).join('') + '</g>';
    },
    // Clickable area of one spoke: an invisible rotated strip (keyboard focusable, tints on hover). Replace with a photo hit area later.
    spoke: function (o) {
      var style = 'left:' + o.x1.toFixed(1) + 'px;top:' + (o.y1 - o.h / 2).toFixed(1) + 'px;width:' + o.len.toFixed(1) + 'px;height:' + o.h +
        'px;transform-origin:0 ' + (o.h / 2) + 'px;transform:rotate(' + o.ang.toFixed(2) + 'deg)';
      return '<button type="button" class="lls-spoke" data-act="paint" data-w="' + o.w + '" data-side="' + o.side + '" data-k="' + o.k +
        '" aria-label="' + esc(o.label) + '" style="' + style + '"></button>';
    },
    // "Arrow B": a quarter-circle arc hugging the outside of the rim over the top of the wheel, tail fading from transparent to solid, filled
    // arrowhead at the end. Clockwise (head at the right) when the wheel is seen from the drive side, mirrored for the rotor side.
    // Sizes follow the 480 px reference drawing (radius ro + 14, stroke 7, head 22 long x 26 wide) scaled to the wheel.
    rollArrow: function (box, ro, ccw) {
      var k = box / 480, c = box / 2, r = ro + 14 * k, sw = 7 * k, L = 22 * k, W = 13 * k, t1 = -138, t2 = -46, id = 'lls-fade-' + (++arrowSeq);
      function P(t, rr) { var q = t * Math.PI / 180; return [c + rr * Math.cos(q), c + rr * Math.sin(q)]; }
      var a = P(t1, r), b = P(t2, r), q = t2 * Math.PI / 180, e = P(t2, r);
      var tx = -Math.sin(q), ty = Math.cos(q), nx = Math.cos(q), ny = Math.sin(q);
      var head = (e[0] + tx * L).toFixed(1) + ',' + (e[1] + ty * L).toFixed(1) + ' ' + (e[0] + nx * W).toFixed(1) + ',' + (e[1] + ny * W).toFixed(1) + ' ' + (e[0] - nx * W).toFixed(1) + ',' + (e[1] - ny * W).toFixed(1);
      return '<svg class="lls-rollarrow" width="' + box + '" height="' + box + '" viewBox="0 0 ' + box + ' ' + box + '" aria-hidden="true" focusable="false">' +
        '<defs><linearGradient id="' + id + '" gradientUnits="userSpaceOnUse" x1="' + a[0].toFixed(1) + '" y1="' + a[1].toFixed(1) + '" x2="' + b[0].toFixed(1) + '" y2="' + b[1].toFixed(1) + '">' +
        '<stop offset="0" stop-color="currentColor" stop-opacity="0"/><stop offset="1" stop-color="currentColor" stop-opacity="1"/></linearGradient></defs>' +
        '<g' + (ccw ? ' transform="matrix(-1 0 0 1 ' + box + ' 0)"' : '') + '>' +
        '<path d="M' + a[0].toFixed(1) + ' ' + a[1].toFixed(1) + ' A' + r.toFixed(1) + ' ' + r.toFixed(1) + ' 0 0 1 ' + b[0].toFixed(1) + ' ' + b[1].toFixed(1) + '" fill="none" stroke="url(#' + id + ')" stroke-width="' + sw.toFixed(2) + '" stroke-linecap="butt"/>' +
        '<polygon points="' + head + '" fill="currentColor"/></g></svg>' +
        '<span class="lls-sr">Wheel turns ' + (ccw ? 'counter-clockwise' : 'clockwise') + ' when rolling forward</span>';
    },
    rim: function (c, ro, bw) {
      return '<span class="lls-rim" style="left:' + (c - ro) + 'px;top:' + (c - ro) + 'px;width:' + (2 * ro) + 'px;height:' + (2 * ro) + 'px;border-width:' + bw + 'px"></span>';
    },
    // Photo ring (config.rimImage): the image, turned about the wheel center. The wrapper falls back to the CSS ring when the image cannot load.
    rimPhoto: function (sh, src, c, ro, bw) {
      // The image is only requested when a wheel with a photo rim is drawn (the Studio opened or a preview shown); a kept Image object keeps it decoded, so the
      // wheel's redraws (every paint) show the ring at once. Eager, synchronous decoding on purpose: a lazy or async image would flash blank on every redraw.
      if (!RIM_KEEP[src] && global.Image) { try { RIM_KEEP[src] = new global.Image(); RIM_KEEP[src].src = src; } catch (e) { /* ignore */ } }
      return '<span class="lls-rimwrap">' + ART.rim(c, ro, bw) +
        '<img class="lls-rim-img" src="' + esc(src) + '" alt="" draggable="false" onerror="this.parentNode.setAttribute(\'data-failed\',\'1\')" style="left:' + sh.left.toFixed(2) + 'px;top:' + sh.top.toFixed(2) +
        'px;width:' + sh.px.toFixed(2) + 'px;height:' + sh.px.toFixed(2) + 'px;transform-origin:' + sh.ox.toFixed(2) + 'px ' + sh.oy.toFixed(2) + 'px;transform:rotate(' + sh.rotDeg.toFixed(3) + 'deg)"></span>';
    },
    // Valve stem: one shape (stem on a nut) in one color, sized from the picture width `box`; the nut sits on the rim's inner edge (`inner` = its distance
    // below the center c) and the stem comes out of its top, VALVE.height * box high in all. A light color gets a thin darker edge.
    stem: function (box, c, inner, color) {
      var sw = box * VALVE.thick, h = box * VALVE.height, nw = box * VALVE.nutW, nh = box * VALVE.nutH, x0 = (nw - sw) / 2, f = function (n) { return +n.toFixed(3); };
      var m = /^#(..)(..)(..)$/.exec(color), rgb = [parseInt(m[1], 16), parseInt(m[2], 16), parseInt(m[3], 16)];
      var light = (0.2126 * rgb[0] + 0.7152 * rgb[1] + 0.0722 * rgb[2]) / 255 > VALVE.lightAbove;
      var edge = '#' + rgb.map(function (v) { return ('0' + Math.round(v * VALVE.edgeShade).toString(16)).slice(-2); }).join('');
      var d = 'M' + f(x0) + ' 0H' + f(x0 + sw) + 'V' + f(h - nh) + 'H' + f(nw) + 'V' + f(h) + 'H0V' + f(h - nh) + 'H' + f(x0) + 'Z';
      return '<svg class="lls-stem" width="' + f(nw) + '" height="' + f(h) + '" viewBox="0 0 ' + f(nw) + ' ' + f(h) + '" style="left:' + f(c - nw / 2) + 'px;top:' + f(c + inner - h) + 'px" aria-hidden="true" focusable="false">' +
        '<path d="' + d + '" fill="' + color + '"' + (light ? ' stroke="' + edge + '" stroke-width="' + VALVE.edgePx + '" stroke-linejoin="miter"' : '') + '/></svg>';
    },
    // The hub is a tinted disc. Replace with a face-on hub photo here.
    hub: function (box, c, hr, cr, hex, minBorder) {
      return '<span class="lls-hub" style="left:' + (c - hr) + 'px;top:' + (c - hr) + 'px;width:' + (2 * hr) + 'px;height:' + (2 * hr) + 'px;border-width:' + Math.max(minBorder || 1.5, box * 0.008) +
        'px;background-color:' + hex + '"></span>' +
        '<span class="lls-cap" style="left:' + (c - cr) + 'px;top:' + (c - cr) + 'px;width:' + (2 * cr) + 'px;height:' + (2 * cr) + 'px"></span>';
    }
  };

  // opts: { ctx: { C, geom, debug }, w, box, pov, sides, th, h, edge, snap, interactive, hitSides, minBorder, dark }
  // hitSides (optional, with interactive): only these sides get tap strips (the Both tab paints only the side that faces the viewer).
  // sides lists the sides to draw back to front: the last one faces the viewer, so its spokes sit on top (no spoke is faded).
  function wheelHtml(o) {
    var C = o.ctx.C, wh = C.W[o.w], g = o.ctx.geom[o.w], box = o.box, dbg = '', hits = '';
    var c = box / 2, ro = box * 0.464, bw = box * 0.028, inner = ro - bw, rimR = inner - 1, scale = rimR / (wh.erd / 2);
    // Photo rim (config.rimImage): spokes end on the photo's inner ellipse, tucked `tuck` px under it; the ring is drawn above the spokes
    var sh = wh.rimImage ? rimShape(wh.rimImage, box, ro) : null, tuck = Math.min(2.5, Math.max(1.5, box * 0.0046)); // 1.5 px on a thumbnail, 2.3 px at 500 px: covers the photo's soft edge and its local bumps
    if (sh) { rimR = sh.meanR; inner = sh.end(180, 0)[1] - c; scale = rimR / (wh.erd / 2); bw = ro - rimR; }
    var html = '<div class="lls-wheel" style="width:' + box + 'px;height:' + box + 'px">';
    if (!sh) html += ART.rim(c, ro, bw) + ART.stem(box, c, inner, wh.valveColor);
    var layers = '';
    o.sides.forEach(function (side) {
      var rh = wh[side].pcd / 2 * scale, list = [];
      g[side].forEach(function (p, k) {
        var a1 = (o.pov === 'drive' ? p.hub : (360 - p.hub) % 360) * Math.PI / 180;
        var a2 = (o.pov === 'drive' ? p.rim : (360 - p.rim) % 360) * Math.PI / 180;
        var x1 = c + rh * Math.sin(a1), y1 = c - rh * Math.cos(a1), x2 = c + rimR * Math.sin(a2), y2 = c - rimR * Math.cos(a2);
        if (sh) { var pe = sh.end(a2 * 180 / Math.PI, tuck); x2 = pe[0]; y2 = pe[1]; }
        var col = o.snap.spokes[o.w][side][k];
        list.push({ x1: x1, y1: y1, x2: x2, y2: y2, hex: C.HEX[col], s: p.s });
        if (o.interactive && (!o.hitSides || o.hitSides.indexOf(side) >= 0)) {
          hits += ART.spoke({
            x1: x1, y1: y1, len: Math.hypot(x2 - x1, y2 - y1), ang: Math.atan2(y2 - y1, x2 - x1) * 180 / Math.PI,
            h: o.h, w: o.w, side: side, k: k, label: 'Spoke ' + (k + 1) + ', ' + sideLower(wh.sideLabels[side]) + ', ' + col
          });
          if (o.ctx.debug) {
            // sandbox-only: hub hole index and rim hole number (both 0-based)
            dbg += '<span class="lls-dbg lls-dbg-' + side + '" style="left:' + (x1 + (x2 - x1) * 0.74).toFixed(1) + 'px;top:' + (y1 + (y2 - y1) * 0.74).toFixed(1) + 'px">h' + k + ' r' + p.rimIndex + '</span>';
          }
        }
      });
      var st;
      if (o.dark) {
        var th = Math.max(1.1, 2.5 * Math.min(1, box / 300)); // both sides: same thickness, full opacity (the wheel looks as it will in real life)
        st = { dark: true, th: th, op: 1, halo: th + 1.5, haloCol: '#ffffff', haloOp: 0.22, side: side };
      } else {
        var e = o.th > 2.5 ? 1 : 0.5;
        st = { dark: false, th: o.th, op: 1, halo: o.th + 2 * e, haloCol: o.edge, haloOp: 1, side: side };
      }
      layers += ART.spokeLayer(list, st);
    });
    html += '<svg class="lls-spokes" width="' + box + '" height="' + box + '" viewBox="0 0 ' + box + ' ' + box + '" aria-hidden="true" focusable="false">' + layers + '</svg>';
    if (sh) html += ART.rimPhoto(sh, wh.rimImage.src, c, ro, bw) + ART.stem(box, c, inner, wh.valveColor); // layers: spokes, ring, valve stem
    html += hits;
    var hr = Math.max(wh.drive.pcd, wh.rotor.pcd) / 2 * scale + box * 0.012;
    html += ART.hub(box, c, hr, hr * 0.4, wh.hubHex[o.snap.hub[o.w]], o.minBorder);
    if (o.arrow) html += ART.rollArrow(box, ro, o.pov === 'rotor'); // rolling-forward arrow for the side shown
    return html + dbg + '</div>';
  }

  /* ------------------------------------------------------------------ patterns */
  var PATS = [
    { id: 'solid', title: 'Solid', desc: 'All accent', f: function () { return true; } },
    // Rotatable patterns count by vrank (clockwise from the first rim hole clockwise of the valve stem). at(vrank, t, mod) says whether a
    // spoke is painted at rotation t; mod = number of rotation positions (Every 4th: 4, Every 3rd on 2:1 wheels: 3, 2 x 2: 4).
    // 2 x 2 (1:1 wheels, 4 positions) / 2 x 1 (2:1 wheels, 3 positions): painted when (vrank + 1 - r) mod m is 0 or 1, i.e. a pair on, then m-2 off.
    { id: 'pairs', title: '2 x 2', desc: 'In pairs', mod: 4, dynMod: true, at: function (vr, t, mod) { return ((((vr + 1 - t) % mod) + mod) % mod) < 2; } },
    { id: 'quarter', title: 'Every 4th', desc: 'One in four', mod: 4, dynMod: true, at: function (vr, t, mod) { return vr % mod === t; } },
    // Drive side / Rotor side are independent toggles on their own side only: all accent -> back to base, otherwise all accent.
    { id: 'drive', title: 'Drive side', desc: 'Toggle drive spokes', toggle: 'drive', f: function () { return true; } },
    { id: 'rotor', title: 'Rotor side', desc: 'Toggle rotor spokes', toggle: 'rotor', f: function () { return true; } },
    { id: 'clear', title: 'Clear', desc: 'Back to base', f: function () { return false; } }
  ];

  // Number of rotation positions of a rotatable pattern on wheel x: Every 4th reads Every 3rd (3 positions) on a wheel whose two sides
  // have different spoke counts, everything else keeps its own count.
  // The words for a side on wheel x, or for the target wheels together (identical labels -> that label; different -> "A / B side").
  function sideLabelOf(x, side) { return S.C.W[x].sideLabels[side]; }
  function sideLabelFor(tg, side) {
    var labels = uniq(tg.map(function (x) { return sideLabelOf(x, side); }));
    return labels.length === 1 ? labels[0] : labels.map(sideShort).join(' / ') + ' side';
  }
  function sideShort(label) { return label.replace(/ side$/i, ''); }   // "Drive side" -> "Drive"
  function sideLower(label) { return label.toLowerCase(); }             // "Drive side" -> "drive side"
  function modOf(q, x) { return q.dynMod && S.C.W[x].drive.n !== S.C.W[x].rotor.n ? 3 : q.mod; }
  function patTitle(q, tg) {
    if (!q.dynMod) return { t: q.title, d: q.desc };
    var m = tg.map(function (x) { return modOf(q, x); }), all3 = m.every(function (v) { return v === 3; }), all4 = m.every(function (v) { return v === 4; });
    if (q.id === 'pairs') return all3 ? { t: '2 x 1', d: 'Two, skip one' } : (all4 ? { t: '2 x 2', d: 'In pairs' } : { t: '2 x 2 / 2 x 1', d: 'In pairs' });
    if (all3) return { t: 'Every 3rd', d: 'One in three' };
    if (all4) return { t: 'Every 4th', d: 'One in four' };
    return { t: 'Every 4th / 3rd', d: 'One in four / three' };
  }
  function patById(id) { return PATS.filter(function (p) { return p.id === id; })[0]; }
  // A pattern button is lit while its rule holds right now (not just after it was clicked), for every wheel the tab targets.
  function sideAllAccent(sn, x, side) { return sn.spokes[x][side].every(function (c) { return c === S.accent; }); }
  // A side button is lit when exactly that side's spokes are accent (the whole side, and nothing on the other side).
  function sideExact(sn, x, side) { var o = side === 'drive' ? 'rotor' : 'drive'; return sideAllAccent(sn, x, side) && sn.spokes[x][o].every(function (c) { return c !== S.accent; }); }
  // The one non-base color a whole side is painted with (any color), or null when the side is base / mixed. Rule b of the side buttons uses it.
  function sideSolid(sn, x, side) {
    var arr = sn.spokes[x][side], c0 = arr[0];
    if (c0 === sn.base[x][side]) return null;
    for (var k = 1; k < arr.length; k++) if (arr[k] !== c0) return null;
    return c0;
  }
  // Which rotation (0..mod-1) of a rotatable pattern the wheel's accent-colored spokes are, or -1 when they are not exactly one of its
  // sets. Nothing is saved for this: it is read from the spokes, so it is right after painting, undo, redo or switching wheel.
  function patRot(q, sn, x) {
    var mod = modOf(q, x);
    for (var t = 0; t < mod; t++) {
      var hit = SIDES.every(function (side) {
        return sn.spokes[x][side].every(function (c, k) { return (c === S.accent) === q.at(S.geom[x][side][k].vrank, t, mod); });
      });
      if (hit) return t;
    }
    return -1;
  }
  function patternLit(q, sn, tg) {
    return tg.every(function (x) {
      if (q.toggle) return sideExact(sn, x, q.toggle);
      if (q.mod) return patRot(q, sn, x) >= 0;
      return SIDES.every(function (side) {
        return sn.spokes[x][side].every(function (c) {
          var isAcc = c === S.accent;
          return q.id === 'solid' && isAcc; // only Solid has a lit state here; Clear is never lit
        });
      });
    });
  }

  /* ------------------------------------------------------------------ session state helpers */
  function snap() { return S.hist[S.hp]; }
  function targets() { return S.tab === 'both' ? S.C.keys.slice() : [S.tab]; }
  function baseSides() { return (S.tab === 'both' || S.view === 'full') ? ['drive', 'rotor'] : [S.view]; }
  function uniq(arr) { var o = {}, out = []; arr.forEach(function (x) { if (!o[x]) { o[x] = 1; out.push(x); } }); return out; }

  function currentValue() { return valueFromSnap(snap(), S.accent); }
  function currentInfo(value) {
    var o = countValue(value, S.C.raw);
    o.replaced = S.replaced.replaced; o.replacedDetail = S.replaced.replacedDetail;
    return o;
  }

  function emit() {
    if (!S || !S.onChange) return;
    var v = currentValue();
    safe(S.onChange, v, currentInfo(v));
  }

  // Push a new history entry made by fn(next), then re-render and notify.
  function commit(fn, patch) {
    var next = cloneSnap(snap());
    fn(next);
    var hist = S.hist.slice(0, S.hp + 1);
    hist.push(next);
    S.hist = hist; S.hp = hist.length - 1; S.activePat = null;
    if (patch) for (var key in patch) S[key] = patch[key];
    render();
    emit();
  }

  /* ------------------------------------------------------------------ rendering */
  function dotHtml(cls, hex, name) { return '<span class="lls-dot ' + cls + '" style="--c:' + esc(hex) + '"' + (name ? ' title="' + esc(name) + '"' : '') + '></span>'; }

  var ICON = {
    flip: '<svg width="16" height="16" viewBox="0 0 16 16" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M2 6h10M9 3l3 3-3 3M14 10H4M7 7l-3 3 3 3"></path></svg>',
    undo: '<svg width="18" height="18" viewBox="0 0 18 18" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M7 4L3 8l4 4M3 8h8a4 4 0 010 8H8"></path></svg>',
    redo: '<svg width="18" height="18" viewBox="0 0 18 18" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M11 4l4 4-4 4M15 8H7a4 4 0 000 8h3"></path></svg>',
    close: '<svg width="18" height="18" viewBox="0 0 18 18" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" aria-hidden="true"><path d="M3 3l12 12M15 3L3 15"></path></svg>',
    chev: '<svg class="lls-slot-chev" width="14" height="14" viewBox="0 0 14 14" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M3 5l4 4 4-4"></path></svg>',
    chat: '<svg width="14" height="14" viewBox="0 0 14 14" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M2 3h10v7H6l-3 2.5V10H2z"></path></svg>'
  };

  function headHtml() {
    var dark = S.theme === 'dark';
    return '<div class="lls-head">' +
      '<div class="lls-head-l"><div class="lls-kicker">SPOKE COLOR STUDIO</div><div class="lls-title" id="lls-title">' + esc(S.C.title) + '</div></div>' +
      '<div class="lls-head-r">' +
      '<button type="button" class="lls-tool lls-theme" data-act="theme"><span class="lls-long">' + (dark ? 'Switch to light view' : 'Switch to dark view') + '</span><span class="lls-short">' + (dark ? 'Light' : 'Dark') + '</span></button>' +
      '<button type="button" class="lls-tool lls-icon-btn lls-close" aria-label="Close studio" data-act="close">' + ICON.close + '</button>' +
      '</div></div>';
  }

  function tabsHtml() {
    var C = S.C, tabs = C.keys.map(function (k) { return { id: k, label: C.W[k].label }; });
    if (C.keys.length > 1) tabs.push({ id: 'both', label: 'Both wheels' });
    return '<div class="lls-tabs">' + tabs.map(function (t) {
      var on = S.tab === t.id;
      return '<button type="button" class="lls-tab' + (on ? ' is-on' : '') + '" aria-pressed="' + on + '" data-act="tab" data-v="' + t.id + '">' + t.label + '</button>';
    }).join('') + '</div>';
  }

  // Pill in the top-left of the stage. The arrow shows which way the wheel turns when the bike rolls forward:
  // counter-clockwise looking at the rotor side, clockwise looking at the drive side.
  function flipHtml(pov, tg) {
    var ccw = pov === 'rotor';
    var arrow = '<path d="M21 12a9 9 0 1 1-9-9c2.52 0 4.93 1 6.74 2.74L21 8"></path><path d="M21 3v5h-5"></path>';
    return '<button type="button" class="lls-flip" data-act="flip" aria-label="Flip wheel" title="Flip wheel">' +
      '<svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">' +
      (ccw ? '<g transform="matrix(-1 0 0 1 24 0)">' + arrow + '</g>' : arrow) + '</svg>' +
      '<span class="lls-flip-t"><span class="lls-flip-a">Flip wheel</span><span class="lls-flip-b">' + esc(sideLabelFor(tg, pov)) + ' ' + DOT + ' rolling forward</span></span></button>';
  }

  function histHtml() {
    return '<div class="lls-hist">' +
      '<button type="button" class="lls-tool lls-icon-btn" aria-label="Undo" data-act="undo"' + (S.hp === 0 ? ' disabled' : '') + '>' + ICON.undo + '</button>' +
      '<button type="button" class="lls-tool lls-icon-btn" aria-label="Redo" data-act="redo"' + (S.hp >= S.hist.length - 1 ? ' disabled' : '') + '>' + ICON.redo + '</button>' +
      '</div>';
  }

  function paletteHtml() {
    return '<div class="lls-dock">' + S.C.palette.map(function (p) {
      var on = S.accent === p.name;
      return '<button type="button" class="lls-dock-btn' + (on ? ' is-on' : '') + '" aria-pressed="' + on + '" data-act="accent" data-name="' + esc(p.name) + '">' +
        dotHtml('lls-dot-lg', p.hex, p.name) + '<span>' + esc(p.name) + '</span></button>';
    }).join('') + '</div>';
  }

  // How tall the dock is (rows of swatches) decides how much room the wheel gets.
  function dockRows() {
    if (S.mobile) return 0;
    var perRow = Math.max(1, Math.floor((860 - 40 + 6) / (62 + 6)));
    return Math.max(1, Math.min(3, Math.ceil(S.C.palette.length / perRow)));
  }
  function stageRoom() { // vertical space left for the wheel on desktop (stage is 744 tall)
    var rows = dockRows();
    return 744 - 46 - 60 - 8 - 6 - (rows * 73 + (rows - 1) * 6);
  }

  // Phone only: the wheel is sized from the screen height so the Colors rows start higher (the first rows of Colors and Patterns are reached with a short
  // scroll while the wheel is still on screen). Single wheel: 34% of the height, 240..330 px, never wider than the screen minus 24 px.
  // Both tab: the two wheels sit side by side (they are only previews there), each half the width: (width - 24 - 12) / 2.
  // S.vh is read once per layout (a phone's URL bar must not resize the wheel while scrolling).
  function phoneWheel(single) {
    return single ? Math.min(S.vw - 24, Math.max(240, Math.min(330, Math.round(S.vh * 0.34)))) : Math.min(250, Math.floor((S.vw - 36) / 2));
  }

  function stageHtml(edge) {
    var C = S.C, sn = snap(), mob = S.mobile, tab = S.tab, dark = S.theme === 'dark';
    var html = '<div class="lls-stage">' + tabsHtml();
    if (tab !== 'both') {
      var w = tab, wh = C.W[w], view = S.view, pov = view === 'full' ? S.pov : view;
      var sides = view === 'full' ? (pov === 'drive' ? ['rotor', 'drive'] : ['drive', 'rotor']) : [view];
      var seg = '<div class="lls-seg">' +
        '<button type="button" class="lls-seg-btn' + (view === 'full' ? ' is-on' : '') + '" aria-pressed="' + (view === 'full') + '" data-act="viewfull"><span>' + (mob ? 'Full' : 'Full wheel') + '</span></button>' +
        '<button type="button" class="lls-seg-btn' + (view === 'drive' ? ' is-on' : '') + '" aria-pressed="' + (view === 'drive') + '" data-act="view" data-v="drive"><span>' + esc(mob ? sideShort(wh.sideLabels.drive) : wh.sideLabels.drive) + ' ' + DOT + ' ' + wh.drive.n + '</span></button>' +
        '<button type="button" class="lls-seg-btn' + (view === 'rotor' ? ' is-on' : '') + '" aria-pressed="' + (view === 'rotor') + '" data-act="view" data-v="rotor"><span>' + esc(mob ? sideShort(wh.sideLabels.rotor) : wh.sideLabels.rotor) + ' ' + DOT + ' ' + wh.rotor.n + '</span></button>' +
        '</div>';
      var thumbSize = mob ? 52 : 104;
      var thumb = '';
      if (view !== 'full') {
        var tsides = pov === 'drive' ? ['rotor', 'drive'] : ['drive', 'rotor'];
        thumb = '<button type="button" class="lls-tool lls-thumb" aria-label="Show full wheel" data-act="viewfull">' +
          wheelHtml({ ctx: S, w: w, box: thumbSize, pov: pov, sides: tsides, th: mob ? 1 : 1.4, h: mob ? 3 : 4, edge: edge, snap: sn, interactive: false, dark: dark }) +
          '<span class="lls-thumb-cap">Full wheel ' + DOT + ' ' + esc(sideShort(wh.sideLabels[pov])) + ' view</span></button>';
      }
      if (mob) {
        html += '<div class="lls-toolbar"><div class="lls-tools-row">' + flipHtml(pov, [w]) + histHtml() + '</div>' + seg + (thumb ? '<div class="lls-tools-row">' + thumb + '</div>' : '') + '</div>';
      } else {
        html += '<div class="lls-toolbar">' + flipHtml(pov, [w]) + seg + histHtml() + '</div>';
      }
      var box = mob ? phoneWheel(true) : Math.min(522, stageRoom() - 8); // 500 -> 522 (+4.4%): uses the spare room above the dock
      html += '<div class="lls-wheel-wrap">' + wheelHtml({ ctx: S, w: w, box: box, pov: pov, sides: sides, th: mob ? 2.6 : 3, h: mob ? 18 : 15, edge: edge, snap: sn, interactive: true, dark: dark, arrow: true }) + '</div>';
      if (!mob) html += thumb;
    } else {
      var bw = mob ? phoneWheel(false) : Math.min(400, stageRoom() - 126); // 390 -> 400: the two wheels + gap fill the stage width
      var bpov = S.bothPov, bsides = bpov === 'drive' ? ['rotor', 'drive'] : ['drive', 'rotor'];
      html += mob ? '<div class="lls-toolbar"><div class="lls-tools-row">' + flipHtml(bpov, C.keys) + histHtml() + '</div></div>' : '<div class="lls-toolbar">' + flipHtml(bpov, C.keys) + histHtml() + '</div>';
      html += '<div class="lls-both">' + C.keys.map(function (k) {
        return '<div class="lls-both-col"><div class="lls-both-title">' + C.W[k].label + ' ' + DOT + ' ' + esc(sideLower(C.W[k].sideLabels[bpov])) + ' view</div>' +
          '<div class="lls-wheel-wrap">' + wheelHtml({ ctx: S, w: k, box: bw, pov: bpov, sides: bsides, th: 2.4, h: 12, edge: edge, snap: sn, interactive: !mob, hitSides: [bpov], dark: dark, arrow: true }) + '</div>' + // desktop: single spokes can be painted here too (data-w = this wheel only)
          '<button type="button" class="lls-tool lls-edit" data-act="editwheel" data-w="' + k + '">Edit ' + k + ' wheel</button></div>';
      }).join('') + '</div>' +
        (mob ? '<div class="lls-both-hint">Tap Edit under a wheel to paint spokes</div>' : '') +
        '<div class="lls-both-note">Colors, hub and patterns you choose here apply to both wheels.</div>';
    }
    return html + paletteHtml() + '</div>';
  }

  // Hub colors on the Both tab: only colors both hubs come in.
  function hubChoices() {
    var C = S.C, tg = targets(), list = C.W[tg[0]].hubColors;
    return list.filter(function (p) { return tg.every(function (x) { return has(C.W[x].hubHex, p.name); }); });
  }
  function popHtml(kind, curName) {
    var list = kind === 'hub' ? hubChoices() : S.C.palette;
    var label = 'Choose ' + (kind === 'hub' ? 'hub' : (kind === 'base' ? 'base spoke' : 'accent spoke')) + ' color';
    if (!list.length) return '<div class="lls-pop lls-pop-empty" role="dialog" aria-label="' + label + '">The two hubs do not share a color. Pick each hub color on its own wheel tab.</div>';
    return '<div class="lls-pop" role="dialog" aria-label="' + label + '">' +
      list.map(function (p) {
        var on = curName === p.name;
        return '<button type="button" class="lls-pop-btn' + (on ? ' is-on' : '') + '" aria-pressed="' + on + '" data-act="popcolor" data-name="' + esc(p.name) + '">' +
          dotHtml('lls-dot-md', p.hex, p.name) + '<span>' + esc(p.name) + '</span></button>';
      }).join('') + '</div>';
  }

  function slotHtml(kind, label, name, dotHex) {
    var on = S.pop === kind;
    return '<div class="lls-slot-wrap"><button type="button" class="lls-slot' + (on ? ' is-on' : '') + '" aria-haspopup="true" aria-expanded="' + on + '" data-act="pop" data-v="' + kind + '">' +
      dotHtml('lls-dot-sm', dotHex) +
      '<span class="lls-slot-txt"><span class="lls-slot-lab">' + esc(label) + '</span><span class="lls-slot-val">' + esc(name) + '</span></span>' + ICON.chev + '</button>' +
      (on ? popHtml(kind, name) : '') + '</div>';
  }

  function sideHtml() {
    var C = S.C, sn = snap(), tab = S.tab, tg = targets(), view = S.view;
    var bSides = baseSides(), bList = [];
    tg.forEach(function (x) { bSides.forEach(function (s) { bList.push(sn.base[x][s]); }); });
    var hubs = uniq(tg.map(function (x) { return sn.hub[x]; })), bases = uniq(bList);
    var hubName = hubs.length === 1 ? hubs[0] : 'Mixed', baseName = bases.length === 1 ? bases[0] : 'Mixed';
    var wName = tab === 'both' ? 'Both wheels' : C.W[tab].label;
    var baseLabel = 'Base spoke color ' + DOT + ' ' + (tab === 'both' ? 'Both wheels' : (view === 'full' ? C.W[tab].label + ', both sides' : cap(tab) + ' ' + sideLower(C.W[tab].sideLabels[view])));

    var counts = dict();
    tg.forEach(function (x) { SIDES.forEach(function (s) { sn.spokes[x][s].forEach(function (c) { counts[c] = (counts[c] || 0) + 1; }); }); });
    var chips = C.palette.filter(function (p) { return counts[p.name]; }).map(function (p) {
      return '<div class="lls-chip">' + dotHtml('lls-dot-xs', p.hex) + '<span>' + esc(p.name) + ' ' + TIMES + counts[p.name] + '</span></div>';
    }).join('');

    var html = '<div class="lls-side">';
    html += '<div><div class="lls-sect-h lls-tight">COLORS</div>' +
      '<div class="lls-hint">Tap a row to change its color. Click a spoke to paint it. Click it again to step back through its earlier colors.</div>' +
      '<div class="lls-slots">' + slotHtml('hub', 'Hub ' + DOT + ' ' + wName, hubName, C.W[tg[0]].hubHex[hubs[0]]) + slotHtml('base', baseLabel, baseName, C.HEX[bases[0]]) +
      slotHtml('accent', 'Accent spoke color', S.accent, C.HEX[S.accent]) + '</div></div>';
    if (S.pop) html += '<button type="button" class="lls-scrim" aria-label="Close color picker" data-act="closepop"></button>';

    html += '<div><div class="lls-sect-h">PATTERNS</div><div class="lls-pat-grid">' + PATS.map(function (q) {
      var on = patternLit(q, sn, tg), ttl = patTitle(q, tg);
      if (q.mod) {
        var rot = '<button type="button" class="lls-rot" data-act="rotq" data-id="' + q.id + '" aria-label="Rotate pattern by one spoke" title="Rotate pattern by one spoke">' +
          '<span class="lls-rot-i"><svg width="14" height="14" viewBox="0 0 14 14" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M11.5 7a4.5 4.5 0 11-1.4-3.25M11.6 1.8v2.4H9.2"></path></svg></span></button>';
        return '<div class="lls-pat-wrap' + (on ? ' is-on has-rot' : '') + '"><button type="button" class="lls-pat-main" aria-pressed="' + on + '" data-act="pattern" data-id="' + q.id + '">' +
          '<span class="lls-pat-t">' + ttl.t + '</span><span class="lls-pat-d">' + ttl.d + '</span></button>' + (on ? rot : '') + '</div>';
      }
      if (q.toggle) { var sl = sideLabelFor(tg, q.toggle); ttl = { t: sl, d: 'Toggle ' + sideLower(sideShort(sl)) + ' spokes' }; }
      else ttl = { t: q.title, d: q.desc };
      return '<button type="button" class="lls-pat' + (on ? ' is-on' : '') + '" aria-pressed="' + on + '" data-act="pattern" data-id="' + q.id + '">' +
        '<span class="lls-pat-t">' + esc(ttl.t) + '</span><span class="lls-pat-d">' + esc(ttl.d) + '</span></button>';
    }).join('') + '</div></div>';

    var title = tab === 'both' ? 'BOTH WHEELS' : C.W[tab].label.toUpperCase();
    html += '<div><div class="lls-sect-h">SPOKE COLORS ' + DOT + ' ' + title + '</div><div class="lls-chips">' + chips + '</div>' + feeHtml() + '</div>';

    var fb = '<button type="button" class="lls-tool lls-flat lls-fb-link" data-act="fbopen">' + ICON.chat + '<span>Send feedback or report a problem</span></button>';
    if (S.mobile) {
      html += '<div class="lls-foot">' + fb + '</div></div>';
      html += '<div class="lls-donebar"><button type="button" class="lls-done" data-act="done">Done</button><div class="lls-savenote">Changes save automatically</div></div>';
      return html;
    }
    html += '<div class="lls-foot"><button type="button" class="lls-done" data-act="done">Done</button><div class="lls-savenote">Changes save automatically</div>' + fb + '</div></div>';
    return html;
  }

  // The fee amount comes from config; the Studio only displays it.
  // config.feeFor(info) (optional): the host decides each wheel's fee; a wheel's line shows only while amount > 0. Without it, the fixed config.fee.
  function feeForWheel(x) {
    var sn = snap(), counts = {};
    SIDES.forEach(function (s) { sn.spokes[x][s].forEach(function (c) { counts[c] = (counts[c] || 0) + 1; }); });
    var r = safe(S.C.raw.feeFor, { wheel: x, counts: counts, base: { drive: sn.base[x].drive, rotor: sn.base[x].rotor } });
    var amount = r && Number(r.amount);
    return { amount: isFinite(amount) && amount > 0 ? amount : 0, label: r && r.label != null ? String(r.label) : '' };
  }
  function feeHtml() {
    var C = S.C, fee = C.fee, both = S.tab === 'both', list = both ? C.keys : [S.tab];
    if (typeof C.raw.feeFor === 'function') {
      var rows = list.map(function (x) {
        var f = feeForWheel(x);
        if (!(f.amount > 0)) return '';
        return '<div class="lls-fee-line is-custom">' + esc((both ? cap(x) + ': ' : '') + (f.label ? f.label + ': ' : '')) + '<b>+' + esc(money(f.amount, C.feeFmt)) + '</b></div>';
      }).join('');
      return feesBox(rows);
    }
    if (!fee) return feesBox('');
    var sn = snap();
    if (C.feeInfo && C.feeInfo.idle) { // feeInfo.idle: while no listed wheel uses 2+ colors, one idle box instead of the muted fee lines
      var anyCustom = list.some(function (x) {
        var d0 = dict();
        SIDES.forEach(function (s) { sn.spokes[x][s].forEach(function (c) { d0[c] = 1; }); });
        return Object.keys(d0).length >= 2;
      });
      if (!anyCustom) return feesBox('');
    }
    // One single-line row per wheel on screen. Same wording in both states; only the styling changes (muted vs accent border + bold amount).
    return feesBox(list.map(function (x) {
      var d = dict();
      SIDES.forEach(function (s) { sn.spokes[x][s].forEach(function (c) { d[c] = 1; }); });
      var custom = Object.keys(d).length >= 2;
      var text = (both ? cap(x) + ': 2+ colors: ' : '2+ colors on this wheel: ');
      return '<div class="lls-fee-line' + (custom ? ' is-custom' : '') + '">' + esc(text) + '<b>+' + esc(money(fee.amount, fee)) + '</b></div>';
    }).join(''));
  }
  // The fee box: plain lines, or (config.feeInfo present) one focusable button with a small "i" that opens the fee popup.
  // No lines (no fee applies): nothing, unless feeInfo.idle is set: then one box in the same place and style with the host's idle text.
  function feesBox(rows) {
    if (!rows) {
      if (!(S.C.feeInfo && S.C.feeInfo.idle)) return '';
      rows = '<div class="lls-fee-line is-idle">' + esc(S.C.feeInfo.idle) + '</div>';
    }
    if (!S.C.feeInfo) return '<div class="lls-fees">' + rows + '</div>';
    return '<div class="lls-fees lls-fees-info" role="button" tabindex="0" aria-haspopup="dialog" data-act="feeinfo">' + rows + '<span class="lls-fee-i" aria-hidden="true">i</span></div>';
  }
  function feeInfoDialogHtml() {
    var fi = S.C.feeInfo, C = S.C;
    return '<div class="lls-fb lls-fi" role="dialog" aria-modal="true"' + (fi.title ? ' aria-labelledby="lls-fi-title"' : '') + '>' +
      (fi.title ? '<div class="lls-fb-title" id="lls-fi-title">' + esc(fi.title) + '</div>' : '') +
      (fi.rows.length ? '<div class="lls-fi-rows">' + fi.rows.map(function (r) {
        return '<div class="lls-fi-row"><div class="lls-fi-head"><span class="lls-fi-label">' + esc(r.label) + '</span>' +
          (r.amount != null ? '<b class="lls-fi-amt">' + esc(money(r.amount, C.feeFmt)) + '</b>' : '') + '</div>' +
          (r.when ? '<div class="lls-fi-when">' + esc(r.when) + '</div>' : '') + '</div>';
      }).join('') + '</div>' : '') +
      (fi.note ? '<div class="lls-fb-note">' + esc(fi.note) + '</div>' : '') +
      '<div class="lls-fb-actions"><button type="button" class="lls-btn-primary" data-act="ficlose">Close</button></div></div>';
  }
  function setFeeInfo(on) {
    if (!S || (on && !S.C.feeInfo)) return;
    S.fi = !!on;
    var ov = S.el.fi;
    if (on) {
      ov.innerHTML = feeInfoDialogHtml();
      ov.hidden = false;
      ov.querySelector('[data-act="ficlose"]').focus({ preventScroll: true });
    } else {
      ov.hidden = true; ov.innerHTML = '';
      var box = S.el.main.querySelector('[data-act="feeinfo"]'); // the box may be gone by now (the fee dropped to nothing): then the dialog itself gets focus
      (box || S.el.root).focus({ preventScroll: true });
    }
  }

  function render() {
    if (!S) return;
    var el = S.el, dark = S.theme === 'dark';
    var edge = dark ? 'rgba(255,255,255,.32)' : 'rgba(0,0,0,.32)';
    // remember scroll + focus so a re-render feels invisible
    var bodyEl = el.main.querySelector('.lls-body'), sideEl = el.main.querySelector('.lls-side');
    var bodyTop = bodyEl ? bodyEl.scrollTop : 0, sideTop = sideEl ? sideEl.scrollTop : 0;
    var active = document.activeElement, fk = (active && el.main.contains(active)) ? focusKey(active) : null;

    el.root.setAttribute('data-theme', S.theme);
    el.main.innerHTML = headHtml() + '<div class="lls-body">' + stageHtml(edge) + sideHtml() + '</div>';

    bodyEl = el.main.querySelector('.lls-body'); sideEl = el.main.querySelector('.lls-side');
    if (bodyEl) bodyEl.scrollTop = bodyTop;
    if (sideEl) sideEl.scrollTop = sideTop;
    if (fk) {
      var found = null;
      Array.prototype.forEach.call(el.main.querySelectorAll('[data-act]'), function (n) { if (!found && !n.disabled && focusKey(n) === fk) found = n; });
      (found || el.root).focus({ preventScroll: true });
    }
  }
  function focusKey(n) {
    var a = [], key;
    for (key in n.dataset) a.push(key + '=' + n.dataset[key]);
    return n.getAttribute('data-act') ? a.join('|') : '';
  }

  /* ------------------------------------------------------------------ actions */
  function paint(w, side, k) {
    commit(function (n) {
      // Each spoke remembers the color it had before the last paint, so repeated clicks
      // cycle: accent -> previous color -> base -> accent (two steps when previous is base).
      var cur = n.spokes[w][side][k], acc = S.accent, base = n.base[w][side];
      var pv = n.prev[w][side][k], pvOk = !!pv && pv !== base && pv !== acc, next;
      if (cur === acc) { next = (pv && pv !== acc) ? pv : base; }
      else if (pvOk && cur === pv) { next = base; }
      else { next = acc; if (!(pvOk && cur === base)) n.prev[w][side][k] = cur; }
      n.spokes[w][side][k] = next;
    });
  }

  function runPattern(id) {
    var q = PATS.filter(function (p) { return p.id === id; })[0], tg = targets(), acc = S.accent;
    if (q.toggle) {
      // Clicking side X (Y = the other side), "accent" = the accent color selected right now:
      //  a) every X spoke already has the accent -> each X spoke steps back to the color it had before (the spoke click cycle's
      //     "previous color" memory, base when there is none); Y untouched.
      //  b) else every Y spoke is one same non-base color -> paint every X spoke with the accent; Y untouched.
      //  c) else 2 x 2 or Every 4th / 3rd is lit -> reset the whole wheel to base, then paint every X spoke with the accent.
      //  d) otherwise -> paint every X spoke with the accent; every other spoke stays exactly as it is.
      var X = q.toggle, Y = X === 'drive' ? 'rotor' : 'drive', sn0 = snap();
      var xHasAccent = tg.every(function (x) { return sideAllAccent(sn0, x, X); });
      var ySolid = tg.every(function (x) { return sideSolid(sn0, x, Y) !== null; });
      var patternLit0 = tg.every(function (x) { return patRot(patById('pairs'), sn0, x) >= 0; }) || tg.every(function (x) { return patRot(patById('quarter'), sn0, x) >= 0; });
      commit(function (n) {
        tg.forEach(function (x) {
          if (xHasAccent) {
            n.spokes[x][X] = n.spokes[x][X].map(function (c, k) { var pv = n.prev[x][X][k]; return (pv && pv !== acc) ? pv : n.base[x][X]; });
            return;
          }
          if (!ySolid && patternLit0) {
            SIDES.forEach(function (s) { n.spokes[x][s] = filled(n.spokes[x][s].length, n.base[x][s]); n.prev[x][s] = filled(n.spokes[x][s].length, null); });
          }
          n.spokes[x][X] = n.spokes[x][X].map(function (c, k) { if (c !== acc) n.prev[x][X][k] = c; return acc; });
        });
      });
      return;
    }
    // Clear: every spoke of the targeted wheel(s) goes to its base color, one undo step. Never lit; nothing to do (no undo step) when all spokes are base already.
    if (id === 'clear') {
      var sn1 = snap();
      if (tg.every(function (x) { return SIDES.every(function (s) { return sn1.spokes[x][s].every(function (c) { return c === sn1.base[x][s]; }); }); })) return;
      commit(function (n) {
        tg.forEach(function (x) {
          SIDES.forEach(function (s) { n.spokes[x][s] = filled(n.spokes[x][s].length, n.base[x][s]); n.prev[x][s] = filled(n.spokes[x][s].length, null); });
        });
      });
      return;
    }
    // Solid / 2 x 2 / Every 4th (3rd) / Clear replace both sides. A second click straight after applying one steps back through history.
    var justApplied = !!S.activePat && S.activePat.id === id && S.activePat.hp === S.hp && S.activePat.tab === S.tab;
    if (justApplied) { S.hp -= 1; S.activePat = null; render(); emit(); return; }
    if (patternLit(q, snap(), tg)) return; // already exactly this state: nothing to do (and no empty history step)
    var hp0 = S.hp, tab0 = S.tab;
    commit(function (n) {
      tg.forEach(function (x) {
        SIDES.forEach(function (s) {
          n.spokes[x][s] = n.spokes[x][s].map(function (_, k) { var on = q.mod ? q.at(S.geom[x][s][k].vrank, 0, modOf(q, x)) : q.f(); return on ? acc : n.base[x][s]; });
          n.prev[x][s] = filled(n.spokes[x][s].length, null);
        });
      });
    });
    S.activePat = { id: id, hp: hp0 + 1, tab: tab0 };
    render();
  }

  // A rotatable pattern (2 x 2, Every 4th / 3rd) is lit at some rotation: move the whole pattern one hole clockwise, each wheel from its own
  // current rotation (4 positions; Every 3rd on 2:1 wheels has 3). One undo step.
  function rotatePattern(id) {
    var q = PATS.filter(function (p) { return p.id === id; })[0];
    var tg = targets(), sn0 = snap(), cur = tg.map(function (x) { return patRot(q, sn0, x); }), acc = S.accent;
    if (!q.mod || cur.some(function (t) { return t < 0; })) return;
    commit(function (n) {
      tg.forEach(function (x, i) {
        var mod = modOf(q, x), t = (cur[i] + 1) % mod;
        SIDES.forEach(function (s) {
          n.spokes[x][s] = n.spokes[x][s].map(function (_, k) { return q.at(S.geom[x][s][k].vrank, t, mod) ? acc : n.base[x][s]; });
          n.prev[x][s] = filled(n.spokes[x][s].length, null);
        });
      });
    });
  }

  function pickPopColor(name) {
    var which = S.pop;
    if (which === 'accent') { S.accent = name; S.pop = null; render(); emit(); return; }
    var sides = baseSides(), tg = targets();
    commit(function (n) {
      tg.forEach(function (x) {
        if (which === 'hub') { if (has(S.C.W[x].hubHex, name)) n.hub[x] = name; return; }
        sides.forEach(function (s) {
          var old = n.base[x][s];
          n.spokes[x][s] = n.spokes[x][s].map(function (c) { return c === old ? name : c; });
          n.base[x][s] = name;
          n.prev[x][s] = filled(n.spokes[x][s].length, null);
        });
      });
    }, { pop: null });
  }

  function sendFeedback() {
    var el = S.el, q = function (id) { return el.root.querySelector(id); };
    if (!q('#lls-fb-msg').value.trim()) return;
    var include = q('#lls-fb-colors').checked;
    var payload = {
      name: q('#lls-fb-name').value, email: q('#lls-fb-email').value, message: q('#lls-fb-msg').value,
      includeColors: include, value: include ? currentValue() : null
    };
    if (S.C.raw.onFeedback) safe(S.C.raw.onFeedback, payload);
    q('#lls-fb-name').value = ''; q('#lls-fb-email').value = ''; q('#lls-fb-msg').value = '';
    q('[data-act="fbsend"]').disabled = true;
    setFb('sent');
  }
  function setFb(state) {
    S.fb = state;
    var ov = S.el.fb;
    ov.hidden = state === 'closed';
    ov.querySelector('.lls-fb-form').hidden = state !== 'open';
    ov.querySelector('.lls-fb-sent').hidden = state !== 'sent';
    if (state === 'open') ov.querySelector('#lls-fb-name').focus({ preventScroll: true });
    else if (state === 'sent') ov.querySelector('[data-act="fbclose"].lls-btn-primary').focus({ preventScroll: true });
    else {
      var link = S.el.main.querySelector('[data-act="fbopen"]');
      (link || S.el.root).focus({ preventScroll: true });
    }
  }

  function onClick(e) {
    if (!S) return;
    if (S.fi && e.target === S.el.fi) { setFeeInfo(false); return; } // click on the dark backdrop around the fee popup
    var t = e.target.closest ? e.target.closest('[data-act]') : null;
    if (!t || !S.el.root.contains(t)) return;
    var act = t.getAttribute('data-act'), d = t.dataset;
    switch (act) {
      case 'close': case 'done': closeStudio(); break;
      case 'theme': S.theme = S.theme === 'dark' ? 'light' : 'dark'; lsSet(THEME_KEY, S.theme); render(); break;
      case 'tab': S.tab = d.v; S.pop = null; render(); break;
      case 'editwheel': S.tab = d.w; render(); break;
      case 'viewfull':
        // The "Full" button and the small thumbnail under a single-side view: both sides, ALWAYS drive side up (also when Full is already active
        // and the wheel was flipped). Going back to the full wheel from any control faces the drive side; Flip works from there.
        S.pov = 'drive'; S.view = 'full';
        render(); break;
      case 'flip': // the Flip wheel pill: look at the wheel from the other side (the Both tab flips both wheels together)
        if (S.tab === 'both') S.bothPov = S.bothPov === 'drive' ? 'rotor' : 'drive';
        else if (S.view === 'full') S.pov = S.pov === 'drive' ? 'rotor' : 'drive';
        else S.view = S.view === 'drive' ? 'rotor' : 'drive';
        render(); break;
      case 'view': S.view = d.v; render(); break;
      case 'undo': if (S.hp > 0) { S.hp--; render(); emit(); } break;
      case 'redo': if (S.hp < S.hist.length - 1) { S.hp++; render(); emit(); } break;
      case 'accent': S.accent = d.name; render(); emit(); break;
      case 'pop': S.pop = d.v; render(); break;
      case 'closepop': S.pop = null; render(); break;
      case 'popcolor': pickPopColor(d.name); break;
      case 'pattern': runPattern(d.id); break;
      case 'rotq': rotatePattern(d.id); break;
      case 'paint': paint(d.w, d.side, Number(d.k)); break;
      case 'fbopen':
        if (typeof S.C.raw.onFeedbackRequest === 'function') { var fv = currentValue(); safe(S.C.raw.onFeedbackRequest, { value: fv, info: currentInfo(fv) }); }
        else setFb('open');
        break;
      case 'feeinfo': setFeeInfo(true); break;
      case 'ficlose': setFeeInfo(false); break;
      case 'fbclose': setFb('closed'); break;
      case 'fbsend': sendFeedback(); break;
    }
  }

  function onKey(e) {
    if (!S) return;
    // A popup the host opened above the Studio (config.onFeedbackRequest) owns the keyboard while focus is inside it:
    // Esc must close only that popup, and Tab must not be pulled back into the Studio.
    var ae = document.activeElement;
    if (ae && ae !== document.body && ae !== document.documentElement && !S.el.overlay.contains(ae)) return;
    if (ae && ae.getAttribute && ae.getAttribute('data-act') === 'feeinfo' && !S.fi && (e.key === 'Enter' || e.key === ' ' || e.key === 'Spacebar')) {
      e.preventDefault(); e.stopPropagation(); setFeeInfo(true); return;
    }
    if (e.key === 'Escape' || e.key === 'Esc') {
      e.preventDefault(); e.stopPropagation();
      if (S.fi) setFeeInfo(false);
      else if (S.fb !== 'closed') setFb('closed');
      else if (S.pop) { S.pop = null; render(); }
      else closeStudio();
      return;
    }
    if (e.key !== 'Tab') return;
    // keep focus inside the dialog (or inside the feedback form while it is open)
    var scope = S.fi ? S.el.fi : S.fb !== 'closed' ? S.el.fb : S.el.root;
    var list = Array.prototype.filter.call(scope.querySelectorAll('button, input, textarea, select, [href]'), function (n) {
      return !n.disabled && !n.hidden && n.offsetWidth > 0 && !n.closest('[hidden]');
    });
    if (!list.length) return;
    var first = list[0], last = list[list.length - 1], a = document.activeElement;
    if (!scope.contains(a) || a === scope) { e.preventDefault(); (e.shiftKey ? last : first).focus(); }
    else if (e.shiftKey && a === first) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && a === last) { e.preventDefault(); first.focus(); }
  }

  /* ------------------------------------------------------------------ layout + lifecycle */
  function layout() {
    var vw = global.innerWidth || document.documentElement.clientWidth, vh = global.innerHeight || document.documentElement.clientHeight;
    var mobile = vw < 820 || vh < 560;
    var scale = mobile ? 1 : Math.min(1, (vw - 24) / 1200, (vh - 24) / 800);
    var changed = mobile !== S.mobile || (mobile && vw !== S.vw);
    S.vw = vw; S.mobile = mobile;
    if (!S.vh || changed) S.vh = vh;
    S.el.overlay.classList.toggle('lls-mobile', mobile);
    S.el.root.style.setProperty('--lls-scale', String(scale));
    return changed;
  }

  function feedbackHtml() {
    return '<div class="lls-fb" role="dialog" aria-modal="true" aria-label="Send feedback">' +
      '<div class="lls-fb-form">' +
      '<div class="lls-fb-head"><div class="lls-fb-title">Send feedback</div><button type="button" class="lls-tool lls-icon-btn lls-close" aria-label="Close feedback form" data-act="fbclose">' + ICON.close + '</button></div>' +
      '<div class="lls-fb-note">Something not working, or a feature you want? Tell us and we will get back to you.</div>' +
      '<div class="lls-field"><label for="lls-fb-name">Name</label><input id="lls-fb-name" type="text" autocomplete="name"></div>' +
      '<div class="lls-field"><label for="lls-fb-email">Email</label><input id="lls-fb-email" type="email" autocomplete="email"></div>' +
      '<div class="lls-field"><label for="lls-fb-msg">Message</label><textarea id="lls-fb-msg" rows="4"></textarea></div>' +
      '<label class="lls-check"><input id="lls-fb-colors" type="checkbox" checked><span>Include a copy of my current spoke colors so you can see what I see</span></label>' +
      '<div class="lls-fb-actions"><button type="button" class="lls-tool lls-btn" data-act="fbclose">Cancel</button><button type="button" class="lls-btn-primary" data-act="fbsend" disabled>Send</button></div>' +
      '</div>' +
      '<div class="lls-fb-sent" hidden>' +
      '<div class="lls-fb-title">Thank you</div><div>Your note was sent. We read every one.</div>' +
      '<div class="lls-fb-actions"><button type="button" class="lls-btn-primary" data-act="fbclose">Back to the studio</button></div>' +
      '</div></div>';
  }

  function showToast() {
    var old = document.querySelector('.lls-toast');
    if (old && old.parentNode) old.parentNode.removeChild(old);
    var t = document.createElement('div');
    t.className = 'lls-toast';
    t.setAttribute('role', 'status');
    t.textContent = 'Spoke colors saved';
    document.body.appendChild(t);
    global.setTimeout(function () { t.className = 'lls-toast is-out'; }, TOAST_MS);
    global.setTimeout(function () { if (t.parentNode) t.parentNode.removeChild(t); }, TOAST_MS + 500);
  }

  function closeStudio() {
    if (!S) return;
    var s = S, v = currentValue(), info = currentInfo(v);
    S = null;
    global.removeEventListener('resize', s.onResize);
    global.removeEventListener('orientationchange', s.onResize);
    document.removeEventListener('keydown', s.onKey, true);
    if (s.el.overlay.parentNode) s.el.overlay.parentNode.removeChild(s.el.overlay);
    document.body.style.overflow = s.prevOverflow;
    if (s.prevFocus && s.prevFocus.focus) { try { s.prevFocus.focus({ preventScroll: true }); } catch (e) { /* element gone */ } }
    showToast();
    if (s.onClose) safe(s.onClose, v, info);
  }

  function open(opts) {
    opts = opts || {};
    if (S) closeStudio();
    var C = normalizeConfig(opts.config, true);
    var start = C.raw.startWheel;
    var tab = (start === 'both' && C.keys.length > 1) ? 'both' : (C.W[start] ? start : (C.W.rear ? 'rear' : C.keys[0]));
    var first = snapFromValue(C, opts.value);
    var accentGiven = opts.value && typeof opts.value === 'object' && opts.value.accent != null;
    var accentOk = accentGiven && has(C.HEX, opts.value.accent);
    var accent = accentOk ? opts.value.accent : C.defaultAccent;
    var replaced = replacedInfo(first, accentGiven && !accentOk);
    var stored = lsGet(THEME_KEY);
    var theme = stored === 'light' || stored === 'dark' ? stored : (C.raw.theme === 'light' ? 'light' : 'dark');

    var overlay = document.createElement('div');
    overlay.className = 'lls-overlay';
    overlay.innerHTML = '<div class="lls-root" role="dialog" aria-modal="true" aria-labelledby="lls-title" tabindex="-1"><div class="lls-main"></div>' +
      '<div class="lls-fb-overlay" hidden>' + feedbackHtml() + '</div><div class="lls-fb-overlay lls-fi-overlay" hidden></div></div>';
    var root = overlay.firstChild;
    S = {
      C: C, geom: buildGeom(C.W), hist: [first], hp: 0, accent: accent, replaced: replaced, pop: null, fb: 'closed', tab: tab, view: 'full', pov: 'drive', bothPov: 'rotor', fi: false, vh: 0, // the Both tab opens on the rotor side; single-wheel tabs keep the drive-side default
      
      theme: theme, activePat: null, mobile: false, vw: 0,
      debug: !!C.raw.debugNumbers, // sandbox-only: labels spokes with hub / rim hole numbers. Never set by the real builder.
      onChange: opts.onChange, onClose: opts.onClose,
      prevFocus: document.activeElement, prevOverflow: document.body.style.overflow,
      el: { overlay: overlay, root: root, main: root.firstChild, fb: root.children[1], fi: root.children[2] }
    };
    S.el.fb.hidden = true;
    S.el.fb.querySelector('.lls-fb-sent').hidden = true;

    // click-away: close only when both press and release land on the dark backdrop
    var downOnBackdrop = false;
    overlay.addEventListener('mousedown', function (e) { downOnBackdrop = e.target === overlay; });
    overlay.addEventListener('touchstart', function (e) { downOnBackdrop = e.target === overlay; }, { passive: true });
    overlay.addEventListener('click', function (e) {
      if (e.target === overlay && downOnBackdrop) closeStudio();
      else onClick(e);
    });
    overlay.addEventListener('input', function (e) {
      if (e.target && e.target.id === 'lls-fb-msg') root.querySelector('[data-act="fbsend"]').disabled = !e.target.value.trim();
    });
    S.onKey = onKey;
    S.onResize = function () { if (S && layout()) render(); };
    document.addEventListener('keydown', S.onKey, true);
    global.addEventListener('resize', S.onResize);
    global.addEventListener('orientationchange', S.onResize);

    document.body.style.overflow = 'hidden';
    document.body.appendChild(overlay);
    layout();
    render();
    root.focus({ preventScroll: true });
  }

  // Small non-interactive wheel (same drawing as the Studio, same look as WheelMini). Used by Step 3.
  //   var p = LoamStudio.preview(el, { config, value, wheel: 'front' | 'rear', size: 240, pov: 'rotor' });
  //   p.update(newValue); p.destroy();
  // pov 'rotor' = the left / non-drive side faces the viewer; the default is the drive side.
  function preview(el, opts) {
    opts = opts || {};
    var C = normalizeConfig(opts.config, true);
    var w = opts.wheel || (C.W.rear ? 'rear' : C.keys[0]);
    if (!C.W[w]) throw new Error('LoamStudio.preview: config has no "' + w + '" wheel');
    var size = num(opts.size, 240), pov = opts.pov === 'rotor' ? 'rotor' : 'drive';
    var dark = opts.dark === true; // dark: light spoke edges and a #6b747e rim, as WheelMini's dark mode (for a dark host card)
    var ctx = { C: C, geom: buildGeom(C.W), debug: false }, th = Math.max(1, size / 80), alive = true;
    var handle = { replaced: 0 };
    function draw(value) {
      if (!alive) return;
      var sn = snapFromValue(C, value, [w]); // only the drawn wheel counts
      handle.replaced = replacedInfo(sn, false).replaced;
      el.innerHTML = '<div class="lls-preview' + (dark ? ' lls-preview-dark' : '') + '" role="img" aria-label="' + esc(C.W[w].label + ' spoke colors, ' + (C.W[w].sideLabelsGiven[pov] ? sideLower(C.W[w].sideLabels[pov]) + ' view' : (pov === 'rotor' ? 'left side view' : 'drive side view'))) + '">' +
        wheelHtml({
          ctx: ctx, w: w, box: size, pov: pov, sides: pov === 'rotor' ? ['drive', 'rotor'] : ['rotor', 'drive'], th: th, h: Math.max(3, th + 2),
          edge: 'rgba(0,0,0,.3)', snap: sn, interactive: false, minBorder: 1, dark: dark
        }) + '</div>';
    }
    draw(opts.value);
    handle.update = draw;
    handle.destroy = function () { if (alive) { alive = false; el.innerHTML = ''; } };
    return handle;
  }

  // Computed lacing, for tests and for the printed map later: { wheel: { drive: [{ hub, rim, rimIndex, rank, vrank, sweep }], rotor: [...] } }
  function geometry(config) {
    var C = normalizeConfig(config, false), G = buildGeom(C.W), out = {};
    C.keys.forEach(function (k) {
      out[k] = {};
      SIDES.forEach(function (side) { out[k][side] = G[k][side].map(function (p) { return { hub: p.hub, rim: p.rim, rimIndex: p.rimIndex, rank: p.rank, vrank: p.vrank, sweep: p.s }; }); });
    });
    return out;
  }

  global.LoamStudio = {
    preview: preview,
    geometry: geometry,
    open: open,
    close: closeStudio,
    isOpen: function () { return !!S; },
    // valve stem numbers (fractions of the picture width) and default color; the backend draws the same shape from rim_photos_contract.json
    valve: VALVE,
    // valve color of a valve stem choice: valveColorHex('Red') -> '#rrggbb' (unknown or missing -> the default dark, one console warning per unknown text); valveColorsOf(components) -> { front, rear }
    valveColorHex: valveColorHex,
    valveColorsOf: valveColorsOf,
    // photo rims: rimImage('Industry Nine' | any other brand, { position: 'front' | 'rear', rotationDeg }) -> a config.rimImage object (or null when the image
    // files cannot be located); rimImageUrls({ wao, i9 }) tells the Studio where the two image files are (default: next to spoke-studio.js)
    rimImage: rimImageFor,
    rimImageUrls: function (u) { if (u && typeof u === 'object') RIM_URLS = u; return RIM_URLS; },
    // sandbox / test switch for FINAL_CROSS_TOP: finalCrossTop() reads it, finalCrossTop('leading' | 'trailing') sets it (the next render uses it)
    finalCrossTop: function (v) { if (v === 'leading' || v === 'trailing') FINAL_CROSS_TOP = v; return FINAL_CROSS_TOP; },
    defaults: function (config) { var C = normalizeConfig(config, true); return valueFromSnap(snapFromValue(C, null), C.defaultAccent); },
    derive: derive
  };
})(window);
